import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import DeleteIcon from "@mui/icons-material/Delete";
import AddBoxIcon from "@mui/icons-material/Add";
import AddBoxImage from "@mui/icons-material/CloudUpload";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Dropzone from "react-dropzone";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Selector from "../select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import MaskedInput from "react-text-mask";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { toast } from "react-toastify";
import Switch from "@mui/material/Switch";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import spinner from "../assign-prescriptions/images/spinner.gif";
import { Input, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff, Help } from "@mui/icons-material";
import SettingIcon from "@mui/icons-material/Settings";
import BOX_TYPE from "../enum/box_type";
import COOL_UNIT_TEMP from "../enum/cool_unit_temp";
import LOCATION_TYPE from "../enum/location_type";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Box from "@mui/material/Box";
import { withTranslation } from "react-i18next";
import ReportsAGGrid from "../reports/reportsGrid/reportsAGGrid";
import VerticalMenu from "./ActionCellRenderer";
import CloseIcon from '@mui/icons-material/Close';
import CONNECTION_TYPE from "../common/connection-type";

let addonUnitsCount = 46;
function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-9]/, /[0-9]/, ":", /[0-9]/, /[0-9]/]}
    //mask={[(/[01]/,'?',/[0-9]/,'|2',/[0-3]/),':',/[0-5]/,/[0-9]/]}
    // mask={
    // (([/([0-1])/]) ? ([/([0-1])/,/[\d]/,':',/([0]|[1]|[2]|[3]|[4]|[5])/,/[\d]/]) : ([/([2])/,/([0-3])/,':',/([0]|[1]|[2]|[3]|[4]|[5])/,/[\d]/]) )
    // }
    // showMask
    />
  );
}
TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

function TabContainer({ children, dir, classes }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 0 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const PaymentGatewayTypes = {
  GLOBAL_PAYMENTS: "9ad90aca-0243-417c-a286-8b7a9aafe7ac",
  AXIA_MED: "f722b17a-4bfd-4c59-a1e3-57ffa5b110c4",
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === "light"
      ? {
        color: "#4fc3f7",
        backgroundColor: "rgb(255, 234, 231)",
      }
      : {
        color: "#4fc3f7",
        backgroundColor: "rgb(255, 234, 231)",
      },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  add: {
    backgroundColor: "#00a7e1",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#6cca98",
      color: "#fff",
    },
  },
  gridActions: {
    display: "inline-block",
    width: "144px",
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    add,
    confirmDelete,
    badd,
    bdelete,
    t,
    clearFilters
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 1,
      })}
    >
      <div className={classes.title}>
        {numSelected > 1 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} {t("Location.SelectedRowsCount")}
          </Typography>
        ) : null}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 1 ? (
          bdelete === true ? (
            <Tooltip
              key="multi-delete"
              title={t("Location.DeleteLocationTooltip")}
            >
              <IconButton
                aria-label="Delete"
                onClick={confirmDelete}
                sx={() => ({
                  "&:hover": { backgroundColor: "#6cca98", color: "#fff" },
                })}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )
        ) : badd === true ? (
          <div style={{ display: 'flex', width: '90px', justifyContent: 'space-between' }}>
            <Tooltip style={{ marginRight: '10px' }} key="clear-filters" title={t("Location.ClearFiltersTooltip")}>
              <IconButton onClick={clearFilters} className={classes.add}>
                <CloseIcon style={{ color: "white" }} />
              </IconButton>
            </Tooltip>
            <Tooltip key="single-add" title={t("Location.AddLocationTooltip")}>
              <IconButton
                aria-label="Add Location"
                className={classes.add}
                onClick={add}
              >
                <AddBoxIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          ""
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const styles = (theme) => ({
  Paper: {
    minWidth: "985px",
  },
  tabsroot: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
  "@media only screen and (min-width: 1024px) and (max-width:1440px) and (orientation:landscape)": {
    root: {
      width: "100%",
      marginTop: theme.spacing.unit * 3,
    },
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    // marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  mytablebody: {
    marginLeft: "0% !important",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  halfTextField: {
    marginRight: "20px",
    width: 300,
  },
  oneThirdTextField: {
    marginRight: "20px",
  },
  dropbox: {
    width: "140px",
    height: "115px",
    float: "right",
    textAlign: "center",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    overflow: "hidden",
    top: "42px",
    right: "2px",
    position: "relative",
    minHight: "48px",
  },
  innerBox: {
    margin: "0 auto",
    display: "block",
    height: "100%",
  },
  dropImage: {
    width: "80%",
    height: "100%",
  },
  dropPic: {
    width: "100%",
    height: "100%",
  },
  errorDiv: {
    paddingTop: "10px",
    color: "red",
  },
  boxType: {
    marginRight: "20px",
    width: 300,
  },
  mypaper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  boxDesign: {
    padding: "24px",
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
  },
  boxId: {
    padding: "10px 0px",
    display: "flex",
  },
  imgProperty: {
    border: "2px solid #000",
    cursor: "pointer",
  },
  spaceDiv: {
    width: "5%",
  },
  paddedDiv: {
    padding: "0px 3% !important",
    lineHeight: "3.6em",
  },
  paddedBoxDiv: {
    padding: "5% 24px !important",
  },
  paddedBoxDivEdit: {
    paddingTop: "24px !important",
  },
  tab2Container: {},
  iconStyle: {
    color: "#0a5d66",
  },
  iconGroup: {
    display: "flex",
  },
  tableDropdown: {
    width: "100px",
    margin: theme.spacing.unit,
  },
  tableIcon: {
    color: "#000",
  },
  captionText: {
    lineHeight: "1",
    color: "#8a8a8a",
    fontSize: "13px",
    textAlign: "center",
  },
  twoChildren: {
    display: "flex",
    justifyContent: "space-between",
  },
  leftChild: {},
  rightChild: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  addRowIcon: {
    width: "20%",
  },
  arrowIcon: {
    display: "flex",
  },
  tableCell: {
    width: "50%",
    padding: "4px 0px 4px 10px !important",
  },
  tableAddRowCell: {
    padding: "4px 20px 4px 32px !important",
  },
  tableTd: {
    padding: "4px 0px 4px 10px !important",
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 32.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
  hidden: {
    display: "none",
  },
  halfTextFieldPOS: {
    marginRight: "20px",
    marginBottom: "20px",
    width: 425,
  },
  primaryButton: {
    background: "#6cca98",
    color: "#fff",
    "&:hover": {
      background: "#6cca98",
      color: "#fff",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.38)",
      cursor: "not-allowed",
      background: "#E4E5E8",
    },
  },
  menuItem: {
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  ThirdTextField: {
    width: "90%",
    marginRight: "46px",
  },
});

let imgFile;

const TransactionSortObj = {
  name: { tableName: '', sortColumn: 'name' },
  description: { tableName: '', sortColumn: 'description' },
  city: { tableName: 'addresses', sortColumn: 'city' },
  parentAccount: { tableName: 'accounts', sortColumn: 'name' },
}

let TransactionFilterObj = {
  searchObject: null,
  pageNo: 0,
  pageSize: 25,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
};

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      orderBy: "created_on",
      selected: [],
      Rows: [],
      page: 0,
      rowsPerPage: 25,
      selectedTab: 0,
      isButtonDisabled: false,
      kiosk_box_id: "",
      isEditable: false,
      searchtext: "",
      addonUnits: [],
      boxTypes: [],
      IsActive: true,
      boxview: true,
      boxadd: true,
      boxdelete: true,
      boxedit: true,
      loader: false,
      TimevalidateDialog: false,
      Sun: false,
      Mon: false,
      Tue: false,
      Wed: false,
      Thu: false,
      Fri: false,
      Sat: false,
      pos: {},
      XWebAuthKey: "",
      XWebId: "",
      XWebTerminalId: "",
      isXWebIdSecretVisible: false,
      isXWebAuthKeySecretVisible: false,
      isXWebTerminalIdSecretVisible: false,
      maxtemp: "",
      setTemp: "",
      mintemp: "",
      errorMaxTemp: false,
      errorMinTemp: false,
      errorSetTemp: false,
      manage_location_name: "",
      location_notes: "",
      location_type_id: "",
      selectCourierType: ["Fed Ex"],
      Fed_Ex: false,
      UPS: false,
      DHL: false,
      third_Party: false,
      Self_Service: false,
      US_Postal: false,
      selectedRadio: "Fed Ex",
      is_marketplace: false,
      simpleOrExpressUI: false,
      SimplifiedEnrollment: false,
      openpath: false,
      totalRecords: 0,
      serial_number: "",
      paymentType: PaymentGatewayTypes.GLOBAL_PAYMENTS,
      selected_regioin: "c10342aa-0c44-41c6-9b50-cf401c7244a9",
      countryList: [],
      preferLanguage: "en",
      preferredLanguage: [
        { id: "en", label: this.props.t("Global.Language.English") },
        { id: "es", label: this.props.t("Global.Language.Spanish") },
        { id: "fr", label: this.props.t("Global.Language.French") },
      ],
      door_open_debounce_interval: 0,
      door_interval_between_two_bins: 0,
      boxTypeId: "",
      allow_multi_bins_pickup: false,
      OpenPathEmailId: "",
      OpenPathPassword: "",
      payroll_deduct: true,
      openPathUserList:[],
      openPathUser:"",
      isUnplugged: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleShowHideXWebIdSecrets = this.handleShowHideXWebIdSecrets.bind(this);
    this.handleShowHideXWebAuthKeySecrets = this.handleShowHideXWebAuthKeySecrets.bind(this);
    this.handleShowHideXWebTerminalIdSecrets = this.handleShowHideXWebTerminalIdSecrets.bind(this);
  }

  componentDidMount() {
    this.isCheckBoxHandler();
    this.getPaymentGateways();
    this.getCountryListWithRegion();
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: "GET",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const accountValues = accounts.map((account) => {
          return { value: account.id, label: account.name };
        });
        if (accounts[0].connection.id === CONNECTION_TYPE.UNPLUGGED) { // for pre-assignment
          this.setState({ accountValues, isUnplugged: true })
        } else {
          this.setState({ accountValues });
        }
      });
    fetch(process.env.REACT_APP_BASEURL + "box-types", {
      method: "GET",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((boxtypes) => {
        if (boxtypes) {
          const boxTypes = boxtypes.map((type) => {
            return { id: type.id, label: type.name };
          });
          this.setState({ boxTypes: boxTypes });
        }
      });
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    if (permissions && permissions.length > 0) {
      let permissionObj = {};
      permissions.map((item) => {
        return item.permission_entity_type === "Manage Boxes" &&
          item.name === "View"
          ? (permissionObj.view = true)
          : item.permission_entity_type === "Manage Boxes" &&
            item.name === "Add"
            ? (permissionObj.add = true)
            : item.permission_entity_type === "Manage Boxes" &&
              item.name === "Modify"
              ? (permissionObj.modify = true)
              : item.permission_entity_type === "Manage Boxes" &&
                item.name === "Delete"
                ? (permissionObj.delete = true)
                : null;
      });
      if (permissionObj.view) {
        this.setState({ boxview: true });
      } else {
        this.setState({ boxview: false });
      }
      if (permissionObj.add) {
        this.setState({ boxadd: true });
      } else {
        this.setState({ boxadd: false });
      }
      if (permissionObj.modify) {
        this.setState({ boxedit: true });
      } else {
        this.setState({ boxedit: false });
      }
      if (permissionObj.delete) {
        this.setState({ boxdelete: true });
      } else {
        this.setState({ boxdelete: false });
      }

      //   if(permissions[16].is_allowed === false){
      //     this.setState({boxedit:false})

      //   }
      //   if(permissions[14].is_allowed === false){
      //     this.setState({boxview:false});
      //     }
      //   if(permissions[17].is_allowed === false){
      //     this.setState({boxdelete:false});
      //   }
      //   if(permissions[15].is_allowed === false){
      //     this.setState({boxadd:false});
      //   }
    } else {
      this.setState({ boxedit: false });
      this.setState({ boxview: false });
      this.setState({ boxdelete: false });
      this.setState({ boxadd: false });
    }
    fetch(process.env.REACT_APP_BASEURL + "roles", {
      method: "GET",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((roleLookupValues) => this.setState({ roleLookupValues }));
  }

  handleChangeRadio = (evt) => {
    let courier = this.state.selectCourierType;
    const index = courier.indexOf(this.state.selectedRadio);
    if (index > -1) {
      courier.splice(index, 1);
    }
    courier.push(evt);
    this.setState({ selectCourierType: courier, selectedRadio: evt }, () => {
      this.isCheckBoxHandler();
    });
  };

  addBox = (event) => {
    this.setState({
      showNewBoxDialog: true,
      box: {},
      operation: "Add",
      name: "",
      description: "",
      type: "",
      avatarPreview: null,
      city: null,
      status: "",
      TimevalidateDialog: false,
      Sun: false,
      Mon: false,
      Tue: false,
      Wed: false,
      Thu: false,
      Fri: false,
      Sat: false,
      pos: {},
      XWebAuthKey: "",
      XWebId: "",
      XWebTerminalId: "",
      maxtemp: "",
      setTemp: "",
      mintemp: "",
      selectedTab: 0,
    });
  };

  deleteBoxes = (event) => {
    this.setState({ loader: true });
    const result = fetch(process.env.REACT_APP_BASEURL + "boxes/" +
      this.state.selected.join(",").trim(","),
      {
        method: "DELETE",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        let isoccupy = JSON.parse(result);
        if (isoccupy.res === true || isoccupy.res === "true") {
          this.setState({ loader: false, selected: [] });
          toast.error(this.props.t("Toast.Error.BoxItemRemove"));
        } else {
          this.setState({ loader: false });
          toast.success(this.props.t("Toast.Success.BoxRemove"));
          const newData = [];
          this.state.data.forEach((item) => {
            if (this.state.selected.indexOf(item.id) === -1) {
              newData.push(item);
            }
          });

          this.setState({
            data: JSON.parse(JSON.stringify(newData)),
            selected: [],
            selectedRowId: null,
          });
        }
        this.gridApi.refreshServerSide();
      });
  };

  handleClose = (event) => {
    this.setState({
      showNewBoxDialog: false,
      box: {},
      errorMessage: "",
      selectedTab: 0,
    });
  };
  handleCloseTimeDialog = (event) => {
    this.setState({ TimevalidateDialog: false });
  };

  handleDrop = (acceptedFiles, rejectedFiles) => {
    this.setState({
      avatarPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };

  removeImg = () => {
    const parent = document.getElementById("avatardropzone");
    let imgSrc = ((parent.children && parent.children[0]).src = "");
    imgFile = new File([imgSrc], "filename");
  };

  handleChange = async (event) => {
    if (event.preventDefault) event.preventDefault();
    const { box } = this.state;
    box[event.target.id || event.target.name] = event.target.value;
    this.setState(box);
  };

  handleLocationType = (value) => {
    this.setState({ manage_location_name: value });
  };

  handleTabChange = (event, value) => {
    this.setState({ selectedTab: value });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  }
  handleOpentimeChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ opentime: event.target.value });
  };
  handleClosetimeChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ closetime: event.target.value });
  };
  handleBlurTime = (event) => {
    if (event.target.value > "23:59") {
      this.setState({ TimevalidateDialog: true });
    }
  };
  handleDaysChange = (value) => {
    if (value === "Sun") {
      this.setState({ Sun: !this.state.Sun });
    }
    if (value === "Mon") {
      this.setState({ Mon: !this.state.Mon });
    }
    if (value === "Tue") {
      this.setState({ Tue: !this.state.Tue });
    }
    if (value === "Wed") {
      this.setState({ Wed: !this.state.Wed });
    }
    if (value === "Thu") {
      this.setState({ Thu: !this.state.Thu });
    }
    if (value === "Fri") {
      this.setState({ Fri: !this.state.Fri });
    }
    if (value === "Sat") {
      this.setState({ Sat: !this.state.Sat });
    }
  };

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ loader: true });
    const count = this.getAddonUnitsCount();
    this.setState({ isButtonDisabled: true });
    if (count > 300) {
      this.setState({ isInsufficientBin: true });
    } else {
      var input = document.querySelector('input[type="file"]');
      var data = new FormData();
      data.append("file", input.files[0]);
      data.append("parent_account_id", this.state.parent_id);
      data.append("name", this.state.name);
      data.append("description", this.state.description);
      data.append("type_id", this.state.type_id);
      data.append("address_line_1", this.state.address1);
      data.append("address_line_2", this.state.address2);
      data.append("city", this.state.city);
      data.append("state", this.state.state);
      data.append("zip", this.state.zip);
      data.append("box_expansions", JSON.stringify(this.state.addonUnits));
      data.append("IsActive", this.state.IsActive);
      data.append("kiosk_box_id", this.state.kiosk_box_id === "" ? "" : this.state.kiosk_box_id);
      data.append("Sunday", this.state.Sun);
      data.append("Monday", this.state.Mon);
      data.append("Tuesday", this.state.Tue);
      data.append("Wednesday", this.state.Wed);
      data.append("Thursday", this.state.Thu);
      data.append("Friday", this.state.Fri);
      data.append("Saturday", this.state.Sat);
      data.append("OpenTime", this.state.opentime);
      data.append("CloseTime", this.state.closetime);
      data.append("HopType", "BoxLevel");
      data.append("courier_type", this.state.selectCourierType);
      data.append("default_courier_type", this.state.selectedRadio);
      data.append("xwebid", this.state.XWebId);
      data.append("xwebauthkey", this.state.XWebAuthKey);
      data.append("xwebterminalid", this.state.XWebTerminalId);
      data.append("location_notes", this.state.location_notes);
      data.append("is_marketplace", this.state.is_marketplace);
      data.append("SimpleStart", this.state.simpleOrExpressUI ? false : true);
      data.append("express_ui", this.state.simpleOrExpressUI ? true : false);
      data.append("SimplifiedEnrollment", this.state.SimplifiedEnrollment);
      data.append("openpath", this.state.openpath);
      data.append("openpathemail", this.state.OpenPathEmailId);
      data.append("openpathpassword", this.state.OpenPathPassword);
      data.append("serial_number", this.state.serial_number);
      data.append("selected_payment_gateway", this.state.paymentType);
      if (this.state.manage_location_name === "Kiosk") {
        data.append("location_type_id", LOCATION_TYPE.Kiosk);
      } else if (this.state.manage_location_name === "Curbside") {
        data.append("location_type_id", LOCATION_TYPE.Curbside);
      } else if (this.state.manage_location_name === "Counter") {
        data.append("location_type_id", LOCATION_TYPE.Counter);
      } else if (this.state.manage_location_name === "Courier") {
        data.append("location_type_id", LOCATION_TYPE.Courier);
      } else if (this.state.manage_location_name === "Other") {
        data.append("location_type_id", LOCATION_TYPE.Other);
      } else if (this.state.manage_location_name === "Bedside") {
        data.append("location_type_id", LOCATION_TYPE.Bedside);
      }
      data.append("selected_regioin", this.state.selected_regioin);
      data.append("preferredlanguage", this.state.preferLanguage);
      data.append(
        "door_open_debounce_interval",
        this.state.door_open_debounce_interval
      );
      data.append(
        "door_interval_between_two_bins",
        this.state.door_interval_between_two_bins
      );
      data.append(
        "allow_multi_bins_pickup",
        this.state && this.state.allow_multi_bins_pickup
      );
      data.append('payroll_deduct', this.state.payroll_deduct);
      data.append('openpathuser', this.state.openPathUser);
      const result = fetch(process.env.REACT_APP_BASEURL + "boxes", {
        method: "POST",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
        body: data,
      });
      result
        .then((result) => {
          result.json().then((res) => {
            this.setState({ loader: false });
            if (res.error) {
              this.setState({ isButtonDisabled: false });
              this.setState({ errorMessage: res.error.message });
            } else {
              this.setState({
                isButtonDisabled: false,
                showNewBoxDialog: false,
                box: {},
                avatarPreview: null,
                errorMessage: "",
                kiosk_box_id: "",
                Sun: false,
                Mon: false,
                Tue: false,
                Wed: false,
                Thu: false,
                Fri: false,
                Sat: false,
                searchtext: "",
              });
              addonUnitsCount = 46;
              toast.success(this.props.t("Toast.Success.BoxAdded"));
              const filterModel = this.gridApi.getFilterModel();
              if (Object.keys(filterModel).length > 0) {
                this.gridApi.setFilterModel(null);
                TransactionFilterObj.searchObject = null;
              }
              // saving pre assignment matrix
              this.setState({ selected: [] })
              this.gridApi.refreshServerSide();
              const is_pre_assignment = ['true', true].includes(sessionStorage.getItem('is_pre_assignment'));
              if(is_pre_assignment) {
                setTimeout(async () => {
                  await this.savePreAssignmentEntries(res);
                }, 20)
              }
            }
          });
        })
        .catch((error) => {
          this.setState({ loader: false });
          this.setState({ errorMessage: error.message });
        });
      this.gridApi.forEachNode(node => node.setSelected(false));
    }
  };

  getAddonUnitsCount = () => {
    const addonUnits = this.state.addonUnits;
    addonUnitsCount = 46;
    addonUnits.map((item) => {
      let boxType = item && item.boxes_type && item.boxes_type.name;
      let expansionId = item && item.expansion_id;
      if (
        boxType === "Cool (Temp controlled with 8 bins)" ||
        expansionId === BOX_TYPE.Cool
      ) {
        addonUnitsCount = addonUnitsCount + 8;
      } else if (
        boxType === "HD36 (Locker add on with 36 bins)" ||
        expansionId === BOX_TYPE.HD36
      ) {
        addonUnitsCount = addonUnitsCount + 36;
      } else if (
        boxType === "L60 (Locker Addon with 60 bins)" ||
        expansionId === BOX_TYPE.L60
      ) {
        addonUnitsCount = addonUnitsCount + 60;
      }
      return true;
    });
    return addonUnitsCount;
  };
  handleChangeHandler = (value) => {
    this.setState({ location_notes: value });
  };
  handleUpdate = (event) => {
    event.preventDefault();
    this.setState({ loader: true });
    const count = this.getAddonUnitsCount();
    this.setState({ isButtonDisabled: true });
    if (count > 300) {
      this.setState({ isInsufficientBin: true });
    } else {
      var input = document.querySelector('input[type="file"]');
      var data = new FormData();
      if (input.files[0] != null || "") {
        data.append("file", input.files[0] || this.state.box.picture_url);
      } else {
        if (imgFile && imgFile.length > 0) {
          data.append("file", imgFile[0]);
        }
      }
      data.append("id", this.state.box.id);
      data.append("parent_account_id", this.state.parent_id);
      data.append("name", this.state.name);
      data.append("description", this.state.description);
      data.append("type_id", this.state.type_id);
      data.append("address_line_1", this.state.address1);
      data.append("address_line_2", this.state.address2);
      data.append("city", this.state.city);
      data.append("state", this.state.state);
      data.append("zip", this.state.zip);
      data.append("boxId", this.state.box.id);
      data.append("box_expansions", JSON.stringify(this.state.addonUnits));
      data.append("IsActive", this.state.IsActive);
      data.append("kiosk_box_id", this.state.kiosk_box_id === "" ? "" : this.state.kiosk_box_id);
      data.append("Sunday", this.state.Sun);
      data.append("Monday", this.state.Mon);
      data.append("Tuesday", this.state.Tue);
      data.append("Wednesday", this.state.Wed);
      data.append("Thursday", this.state.Thu);
      data.append("Friday", this.state.Fri);
      data.append("Saturday", this.state.Sat);
      data.append("OpenTime", this.state.opentime);
      data.append("CloseTime", this.state.closetime);
      data.append("HopType", "BoxLevel");
      data.append("xwebid", this.state.XWebId);
      data.append("xwebauthkey", this.state.XWebAuthKey);
      data.append("xwebterminalid", this.state.XWebTerminalId);
      data.append("location_notes", this.state.location_notes);
      data.append("courier_type", this.state.selectCourierType);
      data.append("default_courier_type", this.state.selectedRadio);
      data.append("SimpleStart", this.state.simpleOrExpressUI ? false : true);
      data.append("express_ui", this.state.simpleOrExpressUI ? true : false);
      data.append("SimplifiedEnrollment", this.state.SimplifiedEnrollment);
      data.append("openpath", this.state.openpath);
      data.append("openpathemail", this.state.OpenPathEmailId);
      data.append("openpathpassword", this.state.OpenPathPassword);
      data.append("serial_number", this.state.serial_number);
      data.append("selected_payment_gateway", this.state.paymentType);
      if (this.state.manage_location_name === "Kiosk") {
        data.append("location_type_id", LOCATION_TYPE.Kiosk);
      } else if (this.state.manage_location_name === "Curbside") {
        data.append("location_type_id", LOCATION_TYPE.Curbside);
      } else if (this.state.manage_location_name === "Counter") {
        data.append("location_type_id", LOCATION_TYPE.Counter);
      } else if (this.state.manage_location_name === "Courier") {
        data.append("location_type_id", LOCATION_TYPE.Courier);
      } else if (this.state.manage_location_name === "Other") {
        data.append("location_type_id", LOCATION_TYPE.Other);
      } else if (this.state.manage_location_name === "Bedside") {
        data.append("location_type_id", LOCATION_TYPE.Bedside);
      }
      data.append("is_marketplace", this.state.is_marketplace);
      data.append("selected_regioin", this.state.selected_regioin);
      data.append("preferredlanguage", this.state.preferLanguage);
      data.append("door_open_debounce_interval", this.state.door_open_debounce_interval);
      data.append("door_interval_between_two_bins", this.state.door_interval_between_two_bins);
      data.append("allow_multi_bins_pickup", this.state && this.state.allow_multi_bins_pickup);
      data.append('payroll_deduct', this.state.payroll_deduct);
      data.append('is_kiosk_log', this.state.is_kiosk_log);
      data.append('openpathuser', this.state.openPathUser);
      const result = fetch(process.env.REACT_APP_BASEURL + "boxes", {
        method: "PUT",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
        body: data,
      });
      result
        .then((result) => {
          result.json().then((res) => {
            const filterModel = this.gridApi.getFilterModel();
            if (Object.keys(filterModel).length > 0) {
              this.gridApi.setFilterModel(null);
              TransactionFilterObj.searchObject = null;
            }
            this.gridApi.refreshServerSide();
            this.setState({
              loader: false,
              isButtonDisabled: false,
              showNewBoxDialog: false,
              box: {},
              avatarPreview: null,
              errorMessage: "",
              Sun: false,
              Mon: false,
              Tue: false,
              Wed: false,
              Thu: false,
              Fri: false,
              Sat: false,
              selected: [],
            });
            addonUnitsCount = 46;
            toast.success(this.props.t("Toast.Success.BoxUpdated"));
            const is_pre_assignment = ['true', true].includes(sessionStorage.getItem('is_pre_assignment'));
            if (is_pre_assignment) {
              setTimeout(async () => {
                await this.updatePreAssignmentEntries(res);
              }, 20)
            }
          });
        })
        .catch((error) => {
          this.setState({ loader: false });
          this.setState({ errorMessage: error.message });
        });
      this.gridApi.forEachNode(node => node.setSelected(false))
    }
  };

  addonConfigClose = () => {
    this.setState({ isInsufficientBin: false, isButtonDisabled: false });
  };


  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    } else {
      this.deleteBoxes();
    }
    this.setState({ deleteDialogOpen: false });
  };

  handleDelete = (event) => {
    this.setState({ loader: true });
    const rowIdToDelete = this.state.selectedRowId;
    const result = fetch(
      process.env.REACT_APP_BASEURL + "boxes/" + rowIdToDelete,
      {
        method: "DELETE",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        let isoccupy = JSON.parse(result);
        if (isoccupy.res === true || isoccupy.res === "true") {
          this.setState({ loader: false, selected: [] });
          toast.error(this.props.t("Toast.Error.BoxItemRemove"));
        } else {
          this.setState({ loader: false });
          toast.success(this.props.t("Toast.Success.BoxRemove"));
          this.handleContextClose(event);
          const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);

          this.setState({
            data: JSON.parse(JSON.stringify(newData)),
            selected: [],
            selectedRowId: null,
          });
          this.handleContextClose(event);
          this.gridApi.refreshServerSide();
        }
      });
  };

  handleKioskBoxIDChangeEvent = (event) => {
    event.persist();
    this.setState({ kiosk_box_id: event.target.value });
  };

  handleBoxScheduleChange = (event) => {
    event.persist();
    this.setState({ loader: true });
    const box_schedule_object = {
      //id: this.state.box.id,
      kiosk_box_id: this.state.kiosk_box_id,
    };
    //check whether box kiosk id already exists or not
    fetch(process.env.REACT_APP_BASEURL + "checkBoxIdExist", {
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(box_schedule_object),
    })
      .then((response) => response.json())
      .then((boxes) => {
        this.setState({ loader: false });
        if (boxes && !boxes.BoxID_Is_Exist) {
        } else {
          toast.error(this.props.t("Toast.Error.BoxIdAlreadyExist"));
          this.setState({ loader: false });
        }
      });
    //ends
  };

  editBoxId = () => {
    this.setState({ isEditable: true });
  };

  onChangeBoxType = (idx) => (evt) => {
    const boxType = this.state.addonUnits.map((item, sidx) => {
      if (idx !== sidx) return item;
      let operation = this.state && this.state.operation;
      return {
        id: operation === "Edit" ? item.id : sidx,
        expansion_id: evt.target.value,
        direction: item.direction,
        connected_box_id: item.connected_box_id,
      };
    });

    this.setState({ addonUnits: boxType });
  };

  onChangeUnitDirection = (idx) => (evt) => {
    const unitDirection = this.state.addonUnits.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        expansion_id: item.expansion_id,
        direction: evt.target.value,
        connected_box_id: item.connected_box_id,
      };
    });

    this.setState({ addonUnits: unitDirection });
  };

  onChangeConnectedDevice = (idx) => (evt) => {
    const connectedDevice = this.state.addonUnits.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        expansion_id: item.expansion_id,
        direction: item.direction,
        connected_box_id: evt.target.value,
      };
    });
    this.setState({ addonUnits: connectedDevice });
  };

  createRow = () => {
    const { classes, t } = this.props;
    let boxType = this.state.boxTypes;
    let boxType_1 = this.state.boxTypes;
    if (boxType !== undefined) {
      boxType = boxType.filter(
        (item) => item.id !== BOX_TYPE.Locker && item.id !== BOX_TYPE.M22 && item.id !== BOX_TYPE.M24
      );
    }
    return this.state.addonUnits.map((val, idx) => (
      <TableRow key={idx}>
        <TableCell align="center" sx={{ width: "12%" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {val.expansion_id === BOX_TYPE.Cool ? (
              <div>
                <IconButton
                  onClick={() => this.handleSeetingsforCoolUnit(idx, val.id)}
                >
                  <SettingIcon className={classes.iconStyle} />
                </IconButton>
              </div>
            ) : (
              ""
            )}
            <div>
              <IconButton onClick={() => this.removeRow(idx)}>
                <RemoveIcon className={classes.iconStyle} />
              </IconButton>
            </div>
          </div>
        </TableCell>
        <TableCell align="left" sx={{ width: "40%" }}>
          <FormControl fullWidth>
            <InputLabel
              htmlFor="type_id"
              sx={{
                marginLeft: "-15px",
                "&.MuiInputLabel-formControl": { top: "5px" },
              }}
            >
              {t("Location.Addons.BoxType")}
            </InputLabel>
            <Select
              value={val.expansion_id || ""}
              onChange={this.onChangeBoxType(idx)}
              inputProps={{
                name: "expansion_id",
                id: "expansion_id1",
              }}
              variant="standard"
            >
              {boxType.map((type, index) => (
                <MenuItem
                  key={index}
                  value={type.id}
                  selected
                  sx={{ height: "46px" }}
                >
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell sx={{ width: "13%" }}>
          <FormControl fullWidth>
            <InputLabel
              htmlFor="age-simple"
              sx={{
                marginLeft: "-15px",
                "&.MuiInputLabel-formControl": { top: "5px" },
              }}
            >
              {t("Location.Addons.Side")}
            </InputLabel>
            <Select
              value={val.direction || ""}
              onChange={this.onChangeUnitDirection(idx)}
              inputProps={{
                name: "direction",
                id: "direction1",
              }}
              variant="standard"
            >
              <MenuItem value={1} sx={{ height: "46px" }}>
                {t("Global.Left")}
              </MenuItem>
              <MenuItem value={2} sx={{ height: "46px" }}>
                {t("Global.Right")}
              </MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell sx={{ width: "45%" }}>
          <FormControl fullWidth>
            <InputLabel
              htmlFor="age-simple"
              sx={{
                marginLeft: "-15px",
                "&.MuiInputLabel-formControl": { top: "5px" },
              }}
            >
              {t("Location.Addons.Connect")}
            </InputLabel>
            <Select
              value={val.connected_box_id || ""}
              onChange={this.onChangeConnectedDevice(idx)}
              inputProps={{
                name: "connected_box_id",
                id: "connected_box_id1",
              }}
              variant="standard"
            >
              {boxType_1.map((type, index) => (
                <MenuItem
                  key={index}
                  value={type.id}
                  selected
                  sx={{ height: "46px" }}
                >
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
      </TableRow>
    ));
  };

  addRow = () => {
    this.setState({
      addonUnits: this.state.addonUnits.concat([
        { id: "", type: "", side: "", connect: "" },
      ]),
    });
  };

  removeRow = (i) => {
    const { addonUnits, operation } = this.state;
    if (operation.toLowerCase() === "edit") {
      const deletedExtension = addonUnits[i].id;
      fetch(
        process.env.REACT_APP_BASEURL + "remove/extension/" + deletedExtension,
        {
          method: "GET",
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((boxes) => {
          this.setState({
            addonUnits: addonUnits.filter((s, sidx) => i !== sidx),
          });
        });
    } else {
      this.setState({
        addonUnits: addonUnits.filter((s, sidx) => i !== sidx),
      });
    }
  };

  handleChangeActive = () => {
    this.setState({ IsActive: !this.state.IsActive });
  };

  handleChangeMarketplace = () => {
    this.setState({ is_marketplace: !this.state.is_marketplace });
  };

  handleShowHideXWebIdSecrets = (column, event) => {
    this.setState({ isXWebIdSecretVisible: !this.state.isXWebIdSecretVisible });
  };

  handleShowHideXWebAuthKeySecrets = (column, event) => {
    this.setState({
      isXWebAuthKeySecretVisible: !this.state.isXWebAuthKeySecretVisible,
    });
  };

  handleShowHideXWebTerminalIdSecrets = (column, event) => {
    this.setState({
      isXWebTerminalIdSecretVisible: !this.state.isXWebTerminalIdSecretVisible,
    });
  };

  handleSeetingsforCoolUnit = (index, id) => {
    this.setState({
      settingDialogOpen: true,
      box_index: index,
      box_expansion_id: id,
    });
    this.getSettings(id);
  };

  handleCloseSettings = () => {
    this.setState({
      maxtemp: "",
      setTemp: "",
      mintemp: "",
      settingDialogOpen: false,
    });
  };

  handleMaxTempChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ maxtemp: event.target.value });
  };

  handleSetTempChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ setTemp: event.target.value });
  };

  handleMinTempChange = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ mintemp: event.target.value });
  };

  isCheckBoxHandler = () => {
    let arr = this.state.selectCourierType;
    this.setState({
      Fed_Ex: false,
      UPS: false,
      DHL: false,
      third_Party: false,
      Self_Service: false,
      US_Postal: false,
    });

    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === "Fed Ex") {
        this.setState({ Fed_Ex: true });
      } else if (arr[i] === "UPS") {
        this.setState({ UPS: true });
      } else if (arr[i] === "DHL") {
        this.setState({ DHL: true });
      } else if (arr[i] === "US Postal Service") {
        this.setState({ US_Postal: true });
      } else if (arr[i] === "3rd Party") {
        this.setState({ third_Party: true });
      } else if (arr[i] === "Self Service(US)") {
        this.setState({ Self_Service: true });
      }
    }
  };

  selectCourierHandler = (value) => {
    let courier = this.state.selectCourierType;
    const index = courier.indexOf(value);
    if (index > -1) {
      courier.splice(index, 1);
    } else {
      courier.push(value);
    }
    this.setState({ selectCourierType: courier }, () => {
      this.isCheckBoxHandler();
    });
  };

  saveCoolBoxSettings = () => {
    if (
      this.state.maxtemp === "" ||
      this.state.mintemp === "" ||
      this.state.setTemp === ""
    ) {
      toast.error(this.props.t("Toast.Error.EnterValue"));
    } else if (
      this.state.maxtemp > COOL_UNIT_TEMP.MAX_TEMP ||
      this.state.maxtemp < COOL_UNIT_TEMP.MIN_TEMP ||
      this.state.maxtemp < this.state.mintemp
    ) {
      this.setState({ errorMaxTemp: true });
    } else if (
      this.state.setTemp > this.state.maxtemp ||
      this.state.setTemp < this.state.mintemp
    ) {
      this.setState({ errorSetTemp: true });
    } else if (
      this.state.mintemp > COOL_UNIT_TEMP.MAX_TEMP ||
      this.state.mintemp < COOL_UNIT_TEMP.MIN_TEMP ||
      this.state.mintemp > this.state.maxtemp
    ) {
      this.setState({ errorMinTemp: true });
    } else {
      const settings = this.state.addonUnits.map((item, sidx) => {
        if (this.state.box_index !== sidx) return item;
        let operation = this.state && this.state.operation;
        return {
          id: operation === "Edit" ? item.id : sidx,
          expansion_id: item.expansion_id,
          direction: item.direction,
          connected_box_id: item.connected_box_id,
          max_temp: this.state.maxtemp,
          target_temp: this.state.setTemp,
          min_temp: this.state.mintemp,
        };
      });
      this.setState({ addonUnits: settings });
      this.setState({
        errorMaxTemp: false,
        errorSetTemp: false,
        errorMinTemp: false,
        settingDialogOpen: false,
      });
    }
  };

  getSettings = (expansionID) => {
    let obj = this.state.addonUnits.filter((x) => x.id === expansionID);
    if (obj && obj.length > 0) {
      this.setState({
        maxtemp: obj[0].max_temp,
        setTemp: obj[0].target_temp,
        mintemp: obj[0].min_temp,
      });
    }
  };

  handleSwitchChange = () => {
    this.setState({
      simpleOrExpressUI: !this.state.simpleOrExpressUI,
    });
  };

  handleSwitchSimplified = (name) => (event) => {
    this.setState({ SimplifiedEnrollment: event.target.checked });
  };


  handleSwitchopenpath = (event) => {
    this.setState({ openpath: event.target.checked });
    localStorage.setItem("openpath", event.target.checked);
  };

  handleChangeOpenPathEmailId = (event) => {
    this.setState({ OpenPathEmailId: event.target.value });
  }

  handleChangeOpenPathPassword = (event) => {
    this.setState({ OpenPathPassword: event.target.value });
  }

  getPaymentGateways = () => {
    fetch(process.env.REACT_APP_BASEURL + "paymentgateways", {
      method: "GET",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((paymentTypes) => {
        this.setState({ paymentGateways: paymentTypes });
      });
  };

  getCountryListWithRegion = () => {
    fetch(process.env.REACT_APP_BASEURL + "regions/list", {
      method: "GET",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((countryListResponse) => {
        this.setState({
          countryList: countryListResponse && countryListResponse.results,
        });
      });
  };

  getOpenPathUser = (OpenPathEmailId, OpenPathPassword) => {
    let openpath_object = {
      OpenPathEmailId,
      OpenPathPassword
    }
    fetch(process.env.REACT_APP_BASEURL + "openpathuserlist", {
      method: "POST",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(openpath_object),
    })
      .then((response) => response.json())
      .then((reslist) => {
        let userlist = []
        if (reslist && reslist.length > 0) {
          for (let i = 0; i < reslist.length; i++) {
            if (reslist[i].status === "A")
              userlist.push({ "id": reslist[i].id, "name": reslist[i].identity.fullName, })
          }
          this.setState({
            openPathUserList: userlist,
          });
        }
      });
  }

  handleChangePaymentGateway = (event) => {
    this.setState({ paymentType: event.target.value });
  };

  handleChangeRegion = (event) => {
    this.setState({ selected_regioin: event.target.value });
  };

  handleChangeDoorOpenDebounceInterval = (event) => {
    this.setState({ door_open_debounce_interval: event.target.value });
  };

  handleChangeDoorIntervalBetweenTwoBins = (event) => {
    this.setState({ door_interval_between_two_bins: event.target.value });
  };

  handleallowMultiBinsPickupForFastlane = (name) => (event) => {
    this.setState({
      allow_multi_bins_pickup: event.target.checked,
    });
  };

  handleSwitchkiosklog = (event) => {
    this.setState({ is_kiosk_log: event.target.checked });
  };

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource()
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = () => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }
        apiCall()

        function apiCall() {
          self.setState({ loader: true });
          fetch(process.env.REACT_APP_BASEURL + 'getBoxes', {
            method: 'POST',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj)
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                self.setState({ loader: false });
                return null;
              }
            })
            .then((data) => {
              self.setState({ totalRecords: data && data.total });
              if (data && data.results) {
                if (data.results.length > 0) {
                  params.successCallback(data.results, data.total);
                  self.setState({ data: data.results, loader: false, isDataEmpty: false, selected: [] })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [], loader: false, isDataEmpty: true, selected: [] })
                }
                self.setState({ loader: false, selected: [] })
              }
            })
            .catch(error => {
              self.setState({ loader: false, selected: [] })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  onRowSelected = (params) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(params.data.id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, params.data.id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    this.setState({ selected: newSelected });
  };

  retrieveData = (selectedObject) => {
    this.setState({ ...selectedObject }, () => {
      this.isCheckBoxHandler();
    })
  }

  ActionCellRenderer = (t, classes) => {
    return (params) => {
      return (
        <VerticalMenu
          t={t}
          classes={classes}
          params={params}
          state={this.state}
          retrieveData={this.retrieveData}
          getOpenPathUser={this.getOpenPathUser}
        />
      )
    }
  }

  savePreAssignmentEntries = async (res) => {
    const boxId = res && res.box && res.box.id;
    const preAssignmentObj = { box_id: boxId };
    fetch(process.env.REACT_APP_BASEURL + "pre-assignment/preAssignmentBoxes", {
      method: "POST",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken.jwtToken,
        'content-type': 'application/json'
      },
      body: JSON.stringify(preAssignmentObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        if (result.success) {
          console.log("Pre Assignment matrix is saved.")
        } else {
          console.log(result.message)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  updatePreAssignmentEntries = async (res) => {
    const boxId = res && res.box && res.box.id;
    const preAssignmentObj = { box_id: boxId };
    fetch(process.env.REACT_APP_BASEURL + "pre-assignment/preAssignmentBoxes", {
      method: "PUT",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken.jwtToken,
        'content-type': 'application/json'
      },
      body: JSON.stringify(preAssignmentObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        if (result.success) {
          console.log("Pre Assignment matrix is updated.")
        } else {
          console.log(result.message)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  render() {
    const { classes, theme, t } = this.props;
    const {
      selected,
      boxTypes,
      isEditable,
      TimevalidateDialog,
      preferLanguage,
      preferredLanguage,
      door_open_debounce_interval,
      // door_interval_between_two_bins,
      box,
      boxTypeId,
    } = this.state;
    const manageLocation = [
      { id: 1, value: "Kiosk", label: t("Global.Patients.Type.Kiosk") },
      { id: 2, value: "Curbside", label: t("Login.CurbsideImageTitle") },
      { id: 3, value: "Counter", label: t("Login.CounterImageTitle") },
      { id: 4, value: "Courier", label: t("Login.CourierImageTitle") },
      { id: 6, value: "Bedside", label: t("Console.Bedside.BedsideTitle") },
      {
        id: 7,
        value: "Other",
        label: t("Report.Stocked.ManualOverride.Other"),
      },
    ];
    const readOnly = this.state.operation === "View";
    var disableSelect = false;
    if (this.state.operation === "View") {
      disableSelect = true;
    } else {
      disableSelect = false;
    }
    const xWebAuthKey = t("Location.POS.WebAuthKeyTooltipTitle");
    const xWebId = t("Location.POS.WebIDTooltipTitle");
    const xWebTerminalId = t("Location.POS.WebTerminalIDTooltipTitle");
    const doorOpenTitle =
      "Add the time interval in seconds, allows patient to pick up the items. It waits till configured time";
    // const doorOpenTitleBetweenTwoBins =
    //   "Add the time interval in seconds, allows to wait for next bin tobe opened";

    const columnDefs = [
      {
        field: "picture_url", headerName: t("Location.Picture"), sortable: false, filter: false, cellRenderer: (params) => (<Avatar alt="" src={params.data.picture_url} />),
      },
      { field: "name", headerName: t("Location.Name") },
      { field: "description", headerName: t("Location.Description") },
      {
        field: "type", headerName: t("Location.Type"), sortable: false, filter: false, cellRenderer: (params) => params.data && params.data.location_type_id !== undefined
          ? params.data && params.data.location_type_id === LOCATION_TYPE.Kiosk
            ? params.data.type && params.data.type.name
            : (params.data.location_type_id) === LOCATION_TYPE.Curbside
              ? "Curb Side"
              : (params.data.location_type_id) === LOCATION_TYPE.Courier
                ? "Courier"
                : (params.data.location_type_id) === LOCATION_TYPE.Counter
                  ? "Counter"
                  : (params.data.location_type_id) === LOCATION_TYPE.Bedside
                    ? "Bedside"
                    : (params.data.location_type_id) === LOCATION_TYPE.Other
                      ? "Other"
                      : ""
          : ""
      },
      {
        field: "city", headerName: t("Location.City"),
        cellRenderer: (params) => params.data.address && params.data.address.city !== "null" ? params.data.address.city : ""
      },
      {
        field: "parentAccount", headerName: t("Location.ParentAccount"),
        cellRenderer: (params) => params.data.account ? params.data.account.name : ''
      },
      {
        field: "actions", headerName: t("Location.Actions"), minWidth: 120, filter: false, sortable: false, cellRenderer: this.ActionCellRenderer(t, classes)
      },
    ]

    return (
      <div>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <div>
          <Dialog
            open={TimevalidateDialog || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <div
              style={{
                background: "linear-gradient(155deg, #ce907b 0%,#ffcfa6 90%)",
              }}
            >
              <DialogContent>
                <DialogContentText
                  style={{ color: "#387371", textAlign: "center" }}
                  id="alert-dialog-description"
                >
                  <p style={{ fontSize: "30px" }}>
                    {t("Location.EnterValidTime")}
                  </p>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(event) => this.handleCloseTimeDialog(event)}
                  color="primary"
                >
                  {t("Location.OkButton")}
                </Button>
              </DialogActions>
            </div>
          </Dialog>
        </div>

        <div className={classes.root}>
          <Dialog
            open={this.state.deleteDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {t("Location.AreYouSureToDelete")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {t("Location.AreYouSureToDeleteBox")}:
                <ul>
                  {this.state.forDeletion &&
                    this.state.forDeletion.map(function (a) {
                      return <li>{a.name}</li>;
                    })}
                </ul>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.deleteConfirmClose}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Location.CancelButton")}
              </Button>
              <Button
                onClick={this.deleteConfirmed}
                color="primary"
                autoFocus
                className={classes.primaryButton}
              >
                {t("Location.DeleteActions")}
              </Button>
            </DialogActions>
          </Dialog>
          {/* Insufficient addon unit box */}

          <Dialog
            open={this.state.isInsufficientBin || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {t("Location.AddOnsUnitExceedText")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.addonConfigClose}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Location.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>

          {/* settings for cool unit */}

          <Dialog
            open={this.state.settingDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: { borderRadius: "5px", maxWidth: "100%", width: "35%" },
            }}
          >
            <DialogTitle id="alert-dialog-title">
              {t("Location.Addons.Settings")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Box sx={{ p: 2 }}>
                  <Box component="div">
                    <TextField
                      error={this.state.errorMaxTemp}
                      variant="standard"
                      margin="normal"
                      value={this.state.maxtemp}
                      id="maxtemp"
                      inputProps={{
                        readOnly: Boolean(readOnly),
                        autocomplete: "new-password",
                        form: {
                          autocomplete: "off",
                        },
                      }}
                      placeholder={t(
                        "Location.Addons.MaxTemperaturePlaceHolder"
                      )}
                      onChange={this.handleMaxTempChange}
                      helperText={
                        this.state.errorMaxTemp === true ? "error" : ""
                      }
                      sx={{ width: "50%" }}
                    />
                    <Box component="div" sx={{ mt: "-1.5rem" }}>
                      <label style={{ marginLeft: "17rem" }}>
                        {" "}
                        {t("Location.Addons.MaxTempAlert")}
                      </label>
                    </Box>
                  </Box>
                  <Box sx={{ display: "inline" }} component="div">
                    <TextField
                      error={this.state.errorSetTemp}
                      variant="standard"
                      className={classes.oneThirdTextField}
                      margin="normal"
                      value={this.state.setTemp}
                      id="settemp"
                      inputProps={{
                        readOnly: Boolean(readOnly),
                        autocomplete: "new-password",
                        form: {
                          autocomplete: "off",
                        },
                      }}
                      placeholder={t("Location.Addons.SetTempPlaceHolder")}
                      onChange={this.handleSetTempChange}
                      helperText={
                        this.state.errorSetTemp === true ? "error" : ""
                      }
                      sx={{ width: "50%" }}
                    />
                    <Box component="div" sx={{ mt: "-1.5rem" }}>
                      <label style={{ marginLeft: "17rem" }}>
                        {t("Location.Addons.TargetTemperature")}
                      </label>
                    </Box>
                  </Box>
                  <Box sx={{ display: "inline" }} component="div">
                    <TextField
                      error={this.state.errorMinTemp}
                      variant="standard"
                      className={classes.oneThirdTextField}
                      margin="normal"
                      value={this.state.mintemp}
                      id="mintemp"
                      inputProps={{
                        readOnly: Boolean(readOnly),
                        autocomplete: "new-password",
                        form: {
                          autocomplete: "off",
                        },
                      }}
                      placeholder={t(
                        "Location.Addons.MinTemperaturePlaceHolder"
                      )}
                      onChange={this.handleMinTempChange}
                      helperText={
                        this.state.errorMinTemp === true ? "error" : ""
                      }
                      sx={{ width: "50%" }}
                    />
                    <Box omponent="div" sx={{ mt: "-1.5rem" }}>
                      <label style={{ marginLeft: "17rem" }}>
                        {t("Location.Addons.MnTempAlert")}
                      </label>
                    </Box>
                  </Box>
                </Box>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleCloseSettings}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Location.Addons.CancelButton")}
              </Button>
              <Button
                onClick={this.saveCoolBoxSettings}
                color="primary"
                autoFocus
                className={classes.primaryButton}
              >
                {t("Location.Addons.SaveButton")}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Edit dialog box */}
          <Dialog
            maxWidth={"sm"}
            fullWidth={true}
            open={this.state.showNewBoxDialog || false}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            classes={{ paper: classes.Paper }}
            PaperProps={{ sx: { height: "717px" } }}
          >
            {this.state.loader ? (
              <div className={classes.spinner}>
                <img
                  className={classes.spinnerImage}
                  src={spinner}
                  alt="loading"
                />
              </div>
            ) : null}
            {this.state.manage_location_name === "Kiosk" ? (
              <div>
                <AppBar position="static" color="default">
                  <Tabs
                    value={this.state.selectedTab}
                    onChange={this.handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant={null}
                  >
                    <Tab
                      label={t("Location.Details.Details")}
                      style={{ minWidth: "160px" }}
                    />
                    <Tab
                      label={t("Location.Settings.Settings")}
                      style={{ minWidth: "160px" }}
                    />
                    <Tab
                      label={t("Location.Addons.AddOns")}
                      style={{ minWidth: "160px" }}
                    />
                    <Tab
                      label={t("Location.POS.PosConfiguration")}
                      style={{ minWidth: "160px" }}
                    />
                  </Tabs>
                </AppBar>

                <SwipeableViews
                  style={{ maxWidth: "1025px" }}
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={this.state.selectedTab}
                  onChangeIndex={() => this.handleChangeIndex}
                >
                  <TabContainer dir={theme.direction}>
                    <div className={classes.paddedBoxDivEdit}>
                      {/* Box title */}
                      <ValidatorForm
                        ref="form"
                        onSubmit={
                          this.state.operation === "Add"
                            ? this.handleSubmit
                            : this.handleUpdate
                        }
                      >
                        <DialogTitle id="form-dialog-title">
                          {t(this.state.operation)}{" "}
                          {t("Location.Details.Locations")}
                        </DialogTitle>
                        <DialogContent>
                          <div className={classes.errorDiv}>
                            {this.state.errorMessage}
                          </div>
                          <div style={{ display: "flex", alignItems: "end" }}>
                            <div style={{ width: "500px" }}>
                              <Selector
                                id="parent_id"
                                label={t("Location.Details.ParentAccount")}
                                values={this.state.accountValues}
                                selected={this.state.parent_id}
                                onBlur={this.handleChange}
                                disableWhenViewSelect={disableSelect}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "5%",
                              }}
                            >
                              <div
                                className={classNames(classes.title)}
                                style={{
                                  color: "#a5a5a5",
                                  float: "left",
                                }}
                              >
                                <span>
                                  {t("Location.Details.LocationIsActiveToggle")}
                                </span>
                              </div>
                              <div
                                className={classNames(classes.flexItemToggle)}
                                style={{ color: "#a5a5a5" }}
                              >
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  disableRipple
                                  checked={this.state.IsActive}
                                  onChange={this.handleChangeActive}
                                  value={this.state.IsActive}
                                  color="primary"
                                  // style={{marginTop:"3%"}}
                                  disabled={this.state.operation === "View"}
                                />
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "2%",
                              }}
                            >
                              <div
                                className={classNames(classes.title)}
                                style={{
                                  color: "#a5a5a5",
                                  float: "left",
                                }}
                              >
                                <span>
                                  {t("Location.Details.MarketplaceToggle")}
                                </span>
                              </div>
                              <div
                                className={classNames(classes.flexItemToggle)}
                                style={{ color: "#a5a5a5" }}
                              >
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  disableRipple
                                  checked={this.state.is_marketplace}
                                  onChange={this.handleChangeMarketplace}
                                  value={this.state.is_marketplace}
                                  color="primary"
                                  disabled={this.state.operation === "View"}
                                />
                              </div>
                            </div>
                          </div>
                          <div className={classes.twoChildren}>
                            <div className={classes.leftChild}>
                              <div style={{ display: "flex" }}>
                                {/* <TextValidator
                                    autoFocus
                                    className={classes.halfTextField}
                                    margin="normal"
                                    value={this.state.name}
                                    id="name"
                                    name="name"
                                    inputProps={{ readOnly: Boolean(readOnly), maxLength: 50 }}
                                    label="Location Name"
                                    placeholder=""
                                    onChange={this.handleChange}
                                  validators={['required','matchRegexp:^[a-zA-Z0-9 ]*$']}
                                  errorMessages={[t('Validation.EnterFirstName'),t('Validation.UseAlphaDigits')]}
                                  />
                                  <TextValidator
                                    className={classes.halfTextField}
                                    margin="normal"
                                    value={this.state.description}
                                    id="description"
                                    name="description"
                                    inputProps={{ readOnly: Boolean(readOnly), maxLength: 100 }}
                                    label="Description"
                                    placeholder=""
                                    onChange={this.handleChange}
                                  /> */}
                              </div>
                              {/* <br />
                                  <br /> */}
                              <div
                                style={{ display: "flex", marginTop: "1rem" }}
                              >
                                <FormControl className={classes.boxType}>
                                  <InputLabel
                                    htmlFor="type_id"
                                    sx={{ marginLeft: "-12px" }}
                                  >
                                    {t("Location.Details.LocationType")}
                                  </InputLabel>
                                  <Select
                                    value={
                                      this.state.manage_location_name || ""
                                    }
                                    onChange={(e) =>
                                      this.handleLocationType(e.target.value)
                                    }
                                    inputProps={{
                                      name: "type_id",
                                      id: "type_id",
                                    }}
                                    readOnly={readOnly}
                                    variant="standard"
                                  >
                                    {manageLocation &&
                                      manageLocation.map((type, index) => (
                                        <MenuItem
                                          key={index}
                                          value={type.value}
                                          selected
                                          className={classes.menuItem}
                                          sx={{ height: "46px" }}
                                        >
                                          {type.label}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>

                                {this.state.manage_location_name !== "Kiosk" ? (
                                  ""
                                ) : (
                                  <FormControl className={classes.boxType}>
                                    <InputLabel
                                      htmlFor="type_id"
                                      sx={{ marginLeft: "-12px" }}
                                    >
                                      {t("Location.Details.BoxType")}
                                    </InputLabel>
                                    <Select
                                      value={this.state.type_id || ""}
                                      onChange={this.handleChange}
                                      inputProps={{
                                        name: "type_id",
                                        id: "type_id",
                                      }}
                                      readOnly={readOnly}
                                      disabled={
                                        this.state.manage_location_name !==
                                        "Kiosk"
                                      }
                                      variant="standard"
                                    >
                                      {boxTypes &&
                                        boxTypes.map((type, index) => (
                                          <MenuItem
                                            key={index}
                                            value={type.id}
                                            selected
                                            className={classes.menuItem}
                                            sx={{ height: "46px" }}
                                          >
                                            {type.label}
                                          </MenuItem>
                                        ))}
                                    </Select>
                                  </FormControl>
                                )}
                              </div>
                              <div style={{ display: "flex" }}>
                                <TextValidator
                                  autoFocus
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.name}
                                  id="name"
                                  name="name"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 50,
                                  }}
                                  label={t("Location.Details.LocationName")}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  validators={["required"]}
                                  errorMessages={t("Validation.Required")}
                                  variant="standard"
                                />
                                <TextValidator
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.description}
                                  id="description"
                                  name="description"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 100,
                                  }}
                                  label={t("Location.Details.Description")}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  variant="standard"
                                />
                              </div>
                              <TextField
                                className={classes.halfTextField}
                                margin="normal"
                                value={this.state.location_notes}
                                id="location_notes"
                                inputProps={{
                                  maxLength: 100,
                                  readOnly: Boolean(readOnly),
                                  autocomplete: "new-password",
                                  form: {
                                    autocomplete: "off",
                                  },
                                }}
                                label={t("Location.Details.LocationNotes")}
                                placeholder=""
                                onChange={(e) =>
                                  this.handleChangeHandler(e.target.value)
                                }
                                style={{ marginTop: "10px" }}
                                variant="standard"
                              />
                            </div>
                            <div className={classes.rightChild}>
                              <div className={classes.dropbox}>
                                {readOnly ? (
                                  <div>
                                    {!this.state.avatarPreview && (
                                      <AddBoxImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.avatarPreview && (
                                      <img
                                        alt=""
                                        src={this.state.avatarPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <Dropzone
                                    id="avatardropzone"
                                    onDrop={this.handleDrop.bind(this)}
                                    className={classes.innerBox}
                                  >
                                    {!this.state.avatarPreview && (
                                      <AddBoxImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.avatarPreview && (
                                      <img
                                        alt=""
                                        src={this.state.avatarPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </Dropzone>
                                )}
                              </div>
                              <div
                                variant="caption"
                                style={{ paddingTop: "40px" }}
                              >
                                <p className={classes.captionText}>
                                  {t("Location.Details.UploadImageTitle")}
                                </p>
                                <Button onClick={this.removeImg}>
                                  {t("Location.Details.RemoveImageButton")}
                                </Button>
                              </div>
                            </div>
                          </div>
                          <Typography
                            variant="title"
                            style={{
                              paddingTop: "40px",
                              fontSize: "1.3125rem",
                              fontWeight: 500,
                              lineHeight: "1.16667em",
                            }}
                          >
                            {t("Location.Details.LocationAddress")}
                          </Typography>
                          <div style={{ display: "flex" }}>
                            <TextValidator
                              margin="dense"
                              className={classes.halfTextField}
                              value={this.state.address1}
                              id="address1"
                              name="address1"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 100,
                              }}
                              label={t("Location.Details.AddressLine1")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterFirstName"),
                                t("Validation.UseAlphaDigits"),
                              ]}
                              variant="standard"
                            />
                            <TextField
                              className={classes.halfTextField}
                              margin="normal"
                              defaultValue={this.state.address2}
                              id="address2"
                              inputProps={{
                                maxLength: 100,
                                readOnly: Boolean(readOnly),
                                autocomplete: "new-password",
                                form: {
                                  autocomplete: "off",
                                },
                              }}
                              label={t("Location.Details.AddressLine2")}
                              placeholder=""
                              onBlur={this.handleChange}
                              style={{ marginTop: "4px" }}
                              variant="standard"
                            />
                          </div>
                          <br />
                          <div style={{ display: "flex" }}>
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.city}
                              id="city"
                              name="city"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t("Location.Details.City")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterCity"),
                                t("Validation.UseAlphabets"),
                              ]}
                              variant="standard"
                            />
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.state}
                              id="state"
                              name="state"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t("Location.Details.State")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterState"),
                                t("Validation.UseAlphabets"),
                              ]}
                              variant="standard"
                            />
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.zip}
                              id="zip"
                              name="zip"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                              }}
                              label={t("Location.Details.Zip")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={["Please Enter Zip"]}
                              variant="standard"
                            />
                          </div>
                          <br />
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.handleClose}
                            color="primary"
                            className={classes.primaryButton}
                          >
                            {this.state.operation === "View"
                              ? t("Location.CloseButton")
                              : t("Location.CancelButton")}
                          </Button>
                          {this.state.operation !== "View" && (
                            <Button
                              type="submit"
                              onClick={
                                this.state.operation === "Add"
                                  ? this.handleSubmit
                                  : this.handleUpdate
                              }
                              disabled={this.state.isButtonDisabled}
                              color="primary"
                              className={classes.primaryButton}
                            >
                              {this.state.operation === "Edit"
                                ? t("Location.UpdateLocationButton")
                                : t("Location.AddLocationButton")}
                            </Button>
                          )}
                        </DialogActions>
                      </ValidatorForm>
                    </div>
                  </TabContainer>
                  {/* Settings tab */}
                  <ValidatorForm
                    ref="form"
                    onSubmit={
                      this.state.operation === "Add"
                        ? this.handleSubmit
                        : this.handleUpdate
                    }
                  >
                    <TabContainer dir={theme.direction}>
                      <Grid
                        xs={12}
                        container
                        spacing={2}
                        sx={{ p: "24px !important" }}
                      >
                        <Grid item xs={5} md={5} lg={5}>
                          <Box sx={{ p: 2, display: "inline" }}>
                            <TextField
                              id="BoxId"
                              name="BoxId"
                              autoFocus={true}
                              autoComplete="off"
                              label={t("Location.Settings.BoxID")}
                              onChange={(event) =>
                                this.handleKioskBoxIDChangeEvent(event)
                              }
                              defaultValue={this.state.kiosk_box_id}
                              disabled={!isEditable ? true : false}
                              inputProps={{
                                autocomplete: "new-password",
                                form: {
                                  autocomplete: "off",
                                },
                              }}
                              variant="standard"
                              sx={{ width: "60%" }}
                            />
                          </Box>
                          <Box sx={{ p: 2, display: "inline" }}>
                            <IconButton
                              onClick={this.editBoxId}
                              sx={{ mt: "21px" }}
                            >
                              <EditIcon className={classes.iconStyle} />
                            </IconButton>
                            <IconButton
                              onClick={(e) => this.handleBoxScheduleChange(e)}
                              sx={{ mt: "21px" }}
                            >
                              <SaveIcon className={classes.iconStyle} />
                            </IconButton>
                          </Box>
                          <Box>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t("Location.Settings.SimplifiedEnrollmentToggle")}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.SimplifiedEnrollment}
                                  color="primary"
                                  onChange={this.handleSwitchSimplified("check")}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t("Location.Exxpress.UI")}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.simpleOrExpressUI}
                                  color="primary"
                                  onChange={this.handleSwitchChange}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t("Location.Settings.OpenPath")}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.openpath}
                                  color="primary"
                                  onChange={this.handleSwitchopenpath}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                          <Box>
                            <FormControl
                              variant="standard"
                              sx={{ m: "16px 16px", minWidth: 235 }}
                            >
                              <InputLabel id="preferred-language-label">
                                {t("Users.UserDetails.PreferredLanguage")}
                              </InputLabel>
                              <Select
                                labelId="preferred-language-label"
                                id="preferred-language-select-standard"
                                value={preferLanguage || ""}
                                readOnly={readOnly}
                                onChange={(e) => {
                                  this.setState({
                                    preferLanguage: e.target.value,
                                  });
                                }}
                                label={t("Users.UserDetails.PreferredLanguage")}
                              >
                                {preferredLanguage.map((item, index) => (
                                  <MenuItem
                                    key={index}
                                    value={item && item.id}
                                    selected
                                  >
                                    {item && item.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                          {(box && box.type_id === BOX_TYPE.FASTLANE) ||
                            boxTypeId === BOX_TYPE.FASTLANE ? (
                            <div>
                              <Box sx={{ mt: "5px", ml: "16px", mb: "5px" }}>
                                <FormControl style={{ marginBottom: "5px" }}>
                                  <InputLabel
                                    htmlFor="door_open_debounce_interval"
                                    sx={{ ml: "-15px" }}
                                  >
                                    Door Open Interval
                                  </InputLabel>
                                  <Input
                                    margin="normal"
                                    style={{ width: "235px", minWidth: "235px" }}
                                    value={door_open_debounce_interval || 0}
                                    id="door_open_debounce_interval"
                                    name="door_open_debounce_interval"
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label="Door Open Debounce Interval"
                                    placeholder="door_open_debounce_interval"
                                    onChange={
                                      this.handleChangeDoorOpenDebounceInterval
                                    }
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title={doorOpenTitle}
                                          className={classes.customWidth}
                                        >
                                          <Help
                                            className={classes.helpIcon}
                                          ></Help>
                                        </Tooltip>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              </Box>
                              {/* <Box sx={{ mt: "5px", ml: "16px", mb: "5px" }}>
                                <FormControl
                                  style={{
                                    marginBottom: "5px",
                                    marginTop: "16px",
                                  }}
                                >
                                  <InputLabel
                                    htmlFor="door_interval_between_two_bins"
                                    sx={{ ml: "-15px" }}
                                  >
                                    Interval to open next bin
                                  </InputLabel>
                                  <Input
                                    style={{ width: "235px", minWidth: "235px" }}
                                    margin="normal"
                                    value={door_interval_between_two_bins || 0}
                                    id="door_interval_between_two_bins"
                                    name="door_interval_between_two_bins"
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label="Door Interval Between Two Bins"
                                    placeholder="door_interval_between_two_bins"
                                    onChange={
                                      this.handleChangeDoorIntervalBetweenTwoBins
                                    }
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title={doorOpenTitleBetweenTwoBins}
                                          className={classes.customWidth}
                                        >
                                          <Help
                                            className={classes.helpIcon}
                                          ></Help>
                                        </Tooltip>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              </Box> */}
                              {/* <Box sx={{ mt: "5px", mb: "5px" }}>
                                <FormControlLabel
                                  label={
                                    <span
                                      style={{
                                        fontSize: 18,
                                        color: "rgb(165, 165, 165)",
                                      }}
                                    >
                                      Allow multibins pickup
                                    </span>
                                  }
                                  labelPlacement="start"
                                  control={
                                    <Switch
                                      classes={{
                                        switchBase: classes.iOSSwitchBase,
                                        bar: classes.iOSBar,
                                        icon: classes.iOSIcon,
                                        iconChecked: classes.iOSIconChecked,
                                        checked: classes.iOSChecked,
                                      }}
                                      checked={this.state.allow_multi_bins_pickup}
                                      color="primary"
                                      onChange={this.handleallowMultiBinsPickupForFastlane(
                                        "check"
                                      )}
                                      value="check"
                                      disabled={this.state.operation === "View"}
                                    />
                                  }
                                />
                              </Box> */}
                            </div>
                          ) : (
                            ""
                          )}
                          <Box>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: 'rgb(165, 165, 165)',
                                  }}>
                                  {t('Accounts.Settings.PayrollDeduction')}
                                </span>
                              }
                              labelPlacement='end'
                              control={
                                <div style={{ marginLeft: '1.99rem' }}>
                                  <Switch
                                    classes={{
                                      switchBase: classes.iOSSwitchBase,
                                      bar: classes.iOSBar,
                                      icon: classes.iOSIcon,
                                      iconChecked: classes.iOSIconChecked,
                                      checked: classes.iOSChecked,
                                    }}
                                    checked={this.state.payroll_deduct}
                                    onChange={(event) =>
                                      this.setState({
                                        payroll_deduct: event.target.checked,
                                      })
                                    }
                                    value='checked'
                                    disabled={this.state.operation === 'View'}
                                    color='primary'
                                  />
                                </div>
                              }
                              style={{ marginLeft: '-40px', marginTop: '3px' }}
                            />
                          </Box>
                          <Box>
                            <FormControlLabel
                              label={
                                <span
                                  style={{
                                    fontSize: 18,
                                    color: "rgb(165, 165, 165)",
                                  }}
                                >
                                  {t("Location.Settings.KisokLog")}
                                </span>
                              }
                              labelPlacement="end"
                              control={
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  checked={this.state.is_kiosk_log}
                                  color="primary"
                                  onChange={this.handleSwitchkiosklog}
                                  value="check"
                                  disabled={this.state.operation === "View"}
                                />
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={4}>
                          <Box sx={{ p: "24px" }}>
                            <Typography
                              variant="title"
                              style={{ color: "black", fontWeight: 500 }}
                            >
                              {t("Location.Settings.HoursOfOperation")}
                            </Typography>
                            <div>
                              <FormControlLabel
                                label={
                                  <span style={{ color: "#000" }}>
                                    {t("Location.Settings.Sunday")}
                                  </span>
                                }
                                control={
                                  <Checkbox
                                    disabled={!isEditable ? true : false}
                                    checked={this.state.Sun}
                                    onChange={() => this.handleDaysChange("Sun")}
                                    value={this.state.Sun}
                                    color="primary"
                                  />
                                }
                              />
                            </div>
                            <div>
                              <FormControlLabel
                                label={
                                  <span style={{ color: "#000" }}>
                                    {t("Location.Settings.Monday")}
                                  </span>
                                }
                                control={
                                  <Checkbox
                                    disabled={!isEditable ? true : false}
                                    checked={this.state.Mon}
                                    onChange={() => this.handleDaysChange("Mon")}
                                    value={this.state.Mon}
                                    color="primary"
                                  />
                                }
                              />
                            </div>
                            <div>
                              <FormControlLabel
                                label={
                                  <span style={{ color: "#000" }}>
                                    {t("Location.Settings.Tuesday")}
                                  </span>
                                }
                                control={
                                  <Checkbox
                                    disabled={!isEditable ? true : false}
                                    checked={this.state.Tue}
                                    onChange={() => this.handleDaysChange("Tue")}
                                    value={this.state.Tue}
                                    color="primary"
                                  />
                                }
                              />
                            </div>
                            <div>
                              <FormControlLabel
                                label={
                                  <span style={{ color: "#000" }}>
                                    {t("Location.Settings.Wednesday")}
                                  </span>
                                }
                                control={
                                  <Checkbox
                                    disabled={!isEditable ? true : false}
                                    checked={this.state.Wed}
                                    onChange={() => this.handleDaysChange("Wed")}
                                    value={this.state.Wed}
                                    color="primary"
                                  />
                                }
                              />
                            </div>
                            <div>
                              <FormControlLabel
                                label={
                                  <span style={{ color: "#000" }}>
                                    {t("Location.Settings.Thursday")}
                                  </span>
                                }
                                control={
                                  <Checkbox
                                    disabled={!isEditable ? true : false}
                                    checked={this.state.Thu}
                                    onChange={() => this.handleDaysChange("Thu")}
                                    value={this.state.Thu}
                                    color="primary"
                                  />
                                }
                              />
                            </div>
                            <div>
                              <FormControlLabel
                                label={
                                  <span style={{ color: "#000" }}>
                                    {t("Location.Settings.Friday")}
                                  </span>
                                }
                                control={
                                  <Checkbox
                                    disabled={!isEditable ? true : false}
                                    checked={this.state.Fri}
                                    onChange={() => this.handleDaysChange("Fri")}
                                    value={this.state.Fri}
                                    color="primary"
                                  />
                                }
                              />
                            </div>

                            <div>
                              <FormControlLabel
                                label={
                                  <span style={{ color: "#000" }}>
                                    {t("Location.Settings.Saturday")}
                                  </span>
                                }
                                control={
                                  <Checkbox
                                    disabled={!isEditable ? true : false}
                                    checked={this.state.Sat}
                                    onChange={() => this.handleDaysChange("Sat")}
                                    value={this.state.Sat}
                                    color="primary"
                                  />
                                }
                              />
                            </div>
                          </Box>
                        </Grid>

                        <Grid item xs={3}>
                          <Box>
                            <TextField
                              disabled={!isEditable ? true : false}
                              id="OpenTime"
                              name="OpenTime"
                              autoComplete="off"
                              fullWidth
                              label={t("Location.Settings.OpenTime")}
                              value={this.state.opentime}
                              inputProps={{
                                maxLength: 8,
                                autocomplete: "new-password",
                                form: {
                                  autocomplete: "off",
                                },
                              }}
                              onChange={this.handleOpentimeChange}
                              onBlur={this.handleBlurTime}
                              variant="standard"
                            />
                            <TextField
                              disabled={!isEditable ? true : false}
                              id="ClosingTime"
                              name="ClosingTime"
                              autoComplete="off"
                              fullWidth
                              label={t("Location.Settings.CloseTime")}
                              value={this.state.closetime}
                              InputProps={{
                                maxLength: 8,
                                autocomplete: "new-password",
                                form: {
                                  autocomplete: "off",
                                },
                              }}
                              onChange={this.handleClosetimeChange}
                              onBlur={this.handleBlurTime}
                              variant="standard"
                              sx={{ mt: "1rem" }}
                            />
                          </Box>
                        </Grid>
                        {this.state.openpath ? (
                          <Grid item xs={3}>
                            <TextValidator
                              id="OpenPathEmailId"
                              name="OpenPathEmailId"
                              label={t("Location.Settings.OpenPathEmailId")}
                              value={this.state.OpenPathEmailId}
                              onChange={this.handleChangeOpenPathEmailId}
                              variant="standard"
                              validators={['required', 'isEmail']}
                              errorMessages={['this field is required', 'email is not valid']}
                            />
                            <TextValidator
                              sx={{ mt: "1rem" }}
                              id="OpenPathPassword"
                              name="OpenPathPassword"
                              type="password"
                              label={t("Location.Settings.OpenPathPassword")}
                              value={this.state.OpenPathPassword}
                              onChange={this.handleChangeOpenPathPassword}
                              variant="standard"
                              validators={['required']}
                              errorMessages={['this field is required']}
                            />
                            <FormControl
                              variant="standard"
                              sx={{ mt: "1rem", minWidth: 235 }}
                            >
                              <InputLabel>
                                {t("Location.Settings.OpenPathUserList")}
                              </InputLabel>
                              <Select
                                value={this.state.openPathUser || ""}
                                readOnly={readOnly}
                                onChange={(e) => {
                                  this.setState({
                                    openPathUser: e.target.value,
                                  });
                                }}
                                label={t("Location.Settings.OpenPathUserList")}
                              >
                                {this.state.openPathUserList && this.state.openPathUserList.map((item, index) => {
                                  return (
                                    <MenuItem
                                      key={index}
                                      value={item && item.id}
                                      selected
                                    >
                                      {item && item.name}
                                    </MenuItem>
                                  )
                                }

                                )}
                              </Select>
                            </FormControl>
                          </Grid>) : (
                          ""
                        )}
                      </Grid>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0",
                          width: "100%",
                        }}
                      >
                        <DialogActions sx={{ padding: "8px 12px 8px 8px" }}>
                          <Button
                            onClick={this.handleClose}
                            color="primary"
                            className={classes.primaryButton}
                          >
                            {this.state.operation === "View"
                              ? t("Location.CloseButton")
                              : t("Location.CancelButton")}
                          </Button>
                          {this.state.operation !== "View" && (
                            <Button
                              type="submit"
                              onClick={
                                this.state.operation === "Add"
                                  ? this.handleSubmit
                                  : this.handleUpdate
                              }
                              disabled={this.state.isButtonDisabled}
                              color="primary"
                              className={classes.primaryButton}
                            >
                              {this.state.operation === "Edit"
                                ? t("Location.UpdateLocationButton")
                                : t("Location.AddLocationButton")}
                            </Button>
                          )}
                        </DialogActions>
                      </div>
                    </TabContainer>
                  </ValidatorForm>

                  <TabContainer dir={theme.direction}>
                    <div>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" sx={{ width: "12%" }}>
                              <div>
                                <IconButton
                                  onClick={this.addRow}
                                  disabled={Boolean(readOnly)}
                                >
                                  <AddIcon className={classes.iconStyle} />
                                </IconButton>
                              </div>
                            </TableCell>
                            <TableCell
                              sx={{ width: "40%", color: "rgb(0, 0, 0, 0.54)" }}
                              align="left"
                            >
                              {t("Location.Addons.Type")}
                            </TableCell>
                            <TableCell align="left" sx={{ width: "13%" }}>
                              <div>
                                <IconButton>
                                  <ArrowBackIcon
                                    className={classes.tableIcon}
                                  />
                                </IconButton>
                                <IconButton>
                                  <ArrowForward className={classes.tableIcon} />
                                </IconButton>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                color: "rgb(0, 0, 0, 0.54)",
                                width: "45%",
                              }}
                            >
                              {t("Location.Addons.Connected")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>{this.createRow()}</TableBody>
                      </Table>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        bottom: "0",
                        width: "100%",
                      }}
                    >
                      <DialogActions sx={{ padding: "8px 12px 8px 8px" }}>
                        <Button
                          onClick={this.handleClose}
                          color="primary"
                          className={classes.primaryButton}
                        >
                          {this.state.operation === "View"
                            ? t("Location.CloseButton")
                            : t("Location.CancelButton")}
                        </Button>
                        {this.state.operation !== "View" && (
                          <Button
                            type="submit"
                            onClick={
                              this.state.operation === "Add"
                                ? this.handleSubmit
                                : this.handleUpdate
                            }
                            disabled={this.state.isButtonDisabled}
                            color="primary"
                            className={classes.primaryButton}
                          >
                            {this.state.operation === "Edit"
                              ? t("Location.UpdateLocationButton")
                              : t("Location.AddLocationButton")}
                          </Button>
                        )}
                      </DialogActions>
                    </div>
                  </TabContainer>

                  <TabContainer dir={theme.direction}>
                    <div
                      className={classes.paddedBoxDivEdit}
                      style={{ paddingLeft: "2%" }}
                    >
                      <ValidatorForm
                        ref="form"
                        onSubmit={
                          this.state.operation === "Add"
                            ? this.handleSubmit
                            : this.handleUpdate
                        }
                      >
                        <div className={classes.twoChildren}>
                          <div style={{ marginBottom: "16px" }}>
                            {t("Location.POS.SelectPaymentGateway")}
                            <Select
                              style={{ width: "455px" }}
                              value={this.state.paymentType || ""}
                              onChange={this.handleChangePaymentGateway}
                              readOnly={this.state.operation === "View"}
                              inputProps={{
                                name: "paymentType",
                                id: "paymentType",
                              }}
                              variant="standard"
                            >
                              {this.state &&
                                this.state.paymentGateways.map(
                                  (type, index) => (
                                    <MenuItem
                                      key={index}
                                      value={type && type.id}
                                      selected
                                    >
                                      {type && type.payment_type}
                                    </MenuItem>
                                  )
                                )}
                            </Select>
                          </div>
                          <div
                            className={classes.leftChild}
                            style={{ marginLeft: "3%" }}
                          >
                            {this.state &&
                              this.state.paymentType ===
                              PaymentGatewayTypes.GLOBAL_PAYMENTS ? (
                              <div>
                                <FormControl className={classes.formControl}>
                                  <InputLabel
                                    htmlFor="XWebId"
                                    sx={{ ml: "-15px" }}
                                  >
                                    {t("Location.POS.WebID")}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldPOS}
                                    margin="normal"
                                    value={this.state.XWebId || ""}
                                    id="XWebId"
                                    name="XWebId"
                                    type={
                                      this.state.isXWebIdSecretVisible
                                        ? "text"
                                        : "password"
                                    }
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label={t("Location.POS.WebID")}
                                    placeholder=""
                                    onChange={this.handleChange}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle XWebId visibility"
                                          onClick={
                                            this.handleShowHideXWebIdSecrets
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state.isXWebIdSecretVisible ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                        <Tooltip
                                          title={xWebId}
                                          className={classes.customWidth}
                                        >
                                          <Help
                                            className={classes.helpIcon}
                                          ></Help>
                                        </Tooltip>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                                <FormControl className={classes.formControl}>
                                  <InputLabel
                                    htmlFor="XWebTerminalId"
                                    sx={{ ml: "-15px" }}
                                  >
                                    Web Terminal Id
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldPOS}
                                    margin="normal"
                                    value={this.state.XWebTerminalId || ""}
                                    id="XWebTerminalId"
                                    name="XWebTerminalId"
                                    type={
                                      this.state.isXWebTerminalIdSecretVisible
                                        ? "text"
                                        : "password"
                                    }
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label="Web Terminal Id"
                                    placeholder=""
                                    onChange={this.handleChange}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle XWebTerminalId visibility"
                                          onClick={
                                            this
                                              .handleShowHideXWebTerminalIdSecrets
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state
                                            .isXWebTerminalIdSecretVisible ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                        <Tooltip
                                          title={xWebTerminalId}
                                          className={classes.customWidth}
                                        >
                                          <Help
                                            className={classes.helpIcon}
                                          ></Help>
                                        </Tooltip>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                                <FormControl className={classes.formControl}>
                                  <InputLabel
                                    htmlFor="XWebAuthKey"
                                    sx={{ ml: "-15px" }}
                                  >
                                    {t("Location.POS.WebAuthKey")}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldPOS}
                                    margin="normal"
                                    value={this.state.XWebAuthKey || ""}
                                    id="XWebAuthKey"
                                    name="XWebAuthKey"
                                    type={
                                      this.state.isXWebAuthKeySecretVisible
                                        ? "text"
                                        : "password"
                                    }
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label={t("Location.POS.WebAuthKey")}
                                    placeholder=""
                                    onChange={this.handleChange}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle XWebAuthKey visibility"
                                          onClick={
                                            this
                                              .handleShowHideXWebAuthKeySecrets
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state
                                            .isXWebAuthKeySecretVisible ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                        <Tooltip
                                          title={xWebAuthKey}
                                          className={classes.customWidth}
                                        >
                                          <Help
                                            className={classes.helpIcon}
                                          ></Help>
                                        </Tooltip>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                                <FormControl>
                                  <InputLabel
                                    htmlFor="Region"
                                    sx={{ ml: "-15px" }}
                                  >
                                    {t("Location.POS.Region")}
                                  </InputLabel>
                                  <Select
                                    style={{ width: "455px" }}
                                    value={this.state.selected_regioin || ""}
                                    onChange={this.handleChangeRegion}
                                    readOnly={this.state.operation === "View"}
                                    inputProps={{
                                      name: "selected_regioin",
                                      id: "selected_regioin",
                                    }}
                                    variant="standard"
                                  >
                                    {this.state &&
                                      this.state.countryList &&
                                      this.state.countryList.map &&
                                      this.state.countryList.map(
                                        (cl, index) => (
                                          <MenuItem
                                            key={index}
                                            value={cl && cl.id}
                                            selected
                                          >
                                            {`${cl && cl.region} (${cl &&
                                              cl.language})`}
                                          </MenuItem>
                                        )
                                      )}
                                  </Select>
                                </FormControl>
                              </div>
                            ) : (
                              <FormControl className={classes.formControl}>
                                <InputLabel
                                  htmlFor="XWebId"
                                  sx={{ ml: "-15px" }}
                                >
                                  {t("Location.POS.SerialNumber")}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextFieldPOS}
                                  margin="normal"
                                  value={this.state.serial_number || ""}
                                  id="serial_number"
                                  name="serial_number"
                                  type="number"
                                  inputProps={{ readOnly: Boolean(readOnly) }}
                                  label={t("Location.POS.SerialNumber")}
                                  onChange={this.handleChange}
                                />
                              </FormControl>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            bottom: "0",
                            width: "100%",
                          }}
                        >
                          <DialogActions sx={{ padding: "8px 28px 8px 8px" }}>
                            <Button
                              onClick={this.handleClose}
                              color="primary"
                              className={classes.primaryButton}
                            >
                              {this.state.operation === "View"
                                ? t("Location.CloseButton")
                                : t("Location.CancelButton")}
                            </Button>
                            {this.state.operation !== "View" && (
                              <Button
                                type="submit"
                                onClick={
                                  this.state.operation === "Add"
                                    ? this.handleSubmit
                                    : this.handleUpdate
                                }
                                disabled={this.state.isButtonDisabled}
                                color="primary"
                                className={classes.primaryButton}
                              >
                                {this.state.operation === "Edit"
                                  ? t("Location.UpdateLocationButton")
                                  : t("Location.AddLocationButton")}
                              </Button>
                            )}
                          </DialogActions>
                        </div>
                      </ValidatorForm>
                    </div>
                  </TabContainer>
                </SwipeableViews>
              </div>
            ) : (
              <div>
                <AppBar
                  style={{ maxWidth: "1025px" }}
                  position="static"
                  color="default"
                >
                  <Tabs
                    value={this.state.selectedTab}
                    onChange={this.handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant={null}
                  >
                    <Tab
                      label={t("Location.Details.Details")}
                      style={{ minWidth: "160px" }}
                    />
                    <Tab
                      label={t("Location.POS.PosConfiguration")}
                      style={{ minWidth: "160px" }}
                    />
                  </Tabs>
                </AppBar>
                <SwipeableViews
                  style={{ maxWidth: "1025px" }}
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={this.state.selectedTab}
                  onChangeIndex={() => this.handleChangeIndex}
                >
                  <TabContainer dir={theme.direction}>
                    <div className={classes.paddedBoxDivEdit}>
                      <ValidatorForm
                        ref="form"
                        onSubmit={
                          this.state.operation === "Add"
                            ? this.handleSubmit
                            : this.handleUpdate
                        }
                      >
                        <DialogTitle id="form-dialog-title">
                          {t(this.state.operation)}{" "}
                          {t("Location.Details.Locations")}
                        </DialogTitle>
                        <DialogContent>
                          <div className={classes.errorDiv}>
                            {this.state.errorMessage}
                          </div>
                          <div style={{ display: "flex", alignItems: "end" }}>
                            <div style={{ width: "500px" }}>
                              <Selector
                                id="parent_id"
                                label={t("Location.Details.ParentAccount")}
                                values={this.state.accountValues}
                                selected={this.state.parent_id}
                                onBlur={this.handleChange}
                                disableWhenViewSelect={disableSelect}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                marginLeft: "5%",
                                alignItems: "center",
                              }}
                            >
                              <div
                                className={classNames(classes.title)}
                                style={{
                                  color: "#a5a5a5",
                                  float: "left",
                                }}
                              >
                                <span>
                                  {t("Location.Details.LocationIsActiveToggle")}
                                </span>
                              </div>
                              <div
                                className={classNames(classes.flexItemToggle)}
                                style={{ color: "#a5a5a5" }}
                              >
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  disableRipple
                                  checked={this.state.IsActive}
                                  onChange={this.handleChangeActive}
                                  value={this.state.IsActive}
                                  color="primary"
                                  disabled={this.state.operation === "View"}
                                />
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                marginLeft: "2%",
                                alignItems: "center",
                              }}
                            >
                              <div
                                className={classNames(classes.title)}
                                style={{
                                  color: "#a5a5a5",
                                  float: "left",
                                }}
                              >
                                <span>
                                  {t("Location.Details.MarketplaceToggle")}
                                </span>
                              </div>
                              <div
                                className={classNames(classes.flexItemToggle)}
                                style={{ color: "#a5a5a5" }}
                              >
                                <Switch
                                  classes={{
                                    switchBase: classes.iOSSwitchBase,
                                    bar: classes.iOSBar,
                                    icon: classes.iOSIcon,
                                    iconChecked: classes.iOSIconChecked,
                                    checked: classes.iOSChecked,
                                  }}
                                  disableRipple
                                  checked={this.state.is_marketplace}
                                  onChange={this.handleChangeMarketplace}
                                  value={this.state.is_marketplace}
                                  color="primary"
                                  disabled={this.state.operation === "View"}
                                  sx={{ "&.Mui-checked": { color: "red" } }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className={classes.twoChildren}>
                            <div className={classes.leftChild}>
                              <div
                                style={{ display: "flex", marginTop: "1rem" }}
                              >
                                <FormControl className={classes.boxType}>
                                  <InputLabel
                                    htmlFor="type_id"
                                    sx={{ marginLeft: "-12px" }}
                                  >
                                    {t("Location.Details.LocationType")}
                                  </InputLabel>
                                  <Select
                                    value={
                                      this.state.manage_location_name || ""
                                    }
                                    onChange={(e) =>
                                      this.handleLocationType(e.target.value)
                                    }
                                    inputProps={{
                                      name: "type_id",
                                      id: "type_id",
                                    }}
                                    readOnly={readOnly}
                                    variant="standard"
                                  >
                                    {manageLocation &&
                                      manageLocation.map((type, index) => (
                                        <MenuItem
                                          key={index}
                                          value={type.value}
                                          selected
                                          className={classes.menuItem}
                                          sx={{ height: "46px" }}
                                        >
                                          {type.label}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                                <FormControl className={classes.boxType}>
                                  <TextField
                                    className={classes.halfTextField}
                                    margin="normal"
                                    value={this.state.location_notes}
                                    id="location_notes"
                                    inputProps={{
                                      readOnly: Boolean(readOnly),
                                      maxLength: 100,
                                    }}
                                    label={t("Location.Details.LocationNotes")}
                                    placeholder=""
                                    onChange={(e) =>
                                      this.handleChangeHandler(e.target.value)
                                    }
                                    style={{ marginTop: "4px" }}
                                    variant="standard"
                                  />
                                </FormControl>
                              </div>
                              <div style={{ display: "flex" }}>
                                <TextValidator
                                  autoFocus
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.name}
                                  id="name"
                                  name="name"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 50,
                                  }}
                                  label={t("Location.Details.LocationName")}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  validators={["required"]}
                                  errorMessages={[t("Validation.Required")]}
                                  variant="standard"
                                />
                                <TextValidator
                                  className={classes.halfTextField}
                                  margin="normal"
                                  value={this.state.description}
                                  id="description"
                                  name="description"
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                    maxLength: 100,
                                  }}
                                  label={t("Location.Details.Description")}
                                  placeholder=""
                                  onChange={this.handleChange}
                                  variant="standard"
                                />
                              </div>
                              {this.state.manage_location_name === "Courier" ? (
                                <div
                                  className={classNames(classes.flexContainer)}
                                >
                                  <Table>
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          borderBottom: "0px",
                                          padding: "8px",
                                        }}
                                      >
                                        <div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.FedEx"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "Fed Ex"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={this.state.Fed_Ex}
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "Fed Ex"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span tyle={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.UPS"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "UPS"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={this.state.UPS}
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "UPS"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.DHL"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "DHL"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={this.state.DHL}
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "DHL"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.USPostalService"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "US Postal Service"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={this.state.US_Postal}
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "US Postal Service"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.3rdParty"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "3rd Party"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={
                                                    this.state.third_Party
                                                  }
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "3rd Party"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                          <div style={{ marginTop: "4px" }}>
                                            <FormControlLabel
                                              label={
                                                <span style={{ color: "#000" }}>
                                                  {t(
                                                    "Location.Details.Courier.SelfServices"
                                                  )}
                                                </span>
                                              }
                                              control={
                                                <Checkbox
                                                  onChange={() =>
                                                    this.selectCourierHandler(
                                                      "Self Service(US)"
                                                    )
                                                  }
                                                  color="primary"
                                                  checked={
                                                    this.state.Self_Service
                                                  }
                                                  disabled={
                                                    this.state.selectedRadio ===
                                                    "Self Service(US)"
                                                  }
                                                />
                                              }
                                            />
                                          </div>
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          borderBottom: "0px",
                                          padding: "8px",
                                        }}
                                      >
                                        <FormControl component="fieldset">
                                          <RadioGroup
                                            aria-label="gender"
                                            name="gender1"
                                            value={this.state.selectedRadio}
                                            onChange={(evt) =>
                                              this.handleChangeRadio(
                                                evt.target.value
                                              )
                                            }
                                          >
                                            <FormControlLabel
                                              value="Fed Ex"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.MakeFedExDefault"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="UPS"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.MakeUPSDefault"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="DHL"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.MakeDHLDefault"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="US Postal Service"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.MakeUSPostalService"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="3rd Party"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.Make3rdParty"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                            <FormControlLabel
                                              value="Self Service(US)"
                                              control={<Radio />}
                                              label={t(
                                                "Location.Details.Courier.SelfServiceUS"
                                              )}
                                              style={{ marginTop: "4px" }}
                                            />
                                          </RadioGroup>
                                        </FormControl>
                                      </TableCell>
                                    </TableRow>
                                  </Table>
                                </div>
                              ) : (
                                ""
                              )}
                              {this.state.manage_location_name !== "Kiosk" ? (
                                ""
                              ) : (
                                <FormControl className={classes.boxType}>
                                  <InputLabel
                                    htmlFor="type_id"
                                    sx={{ marginLeft: "-12px" }}
                                  >
                                    {t("Location.Details.BoxType")}
                                  </InputLabel>
                                  <Select
                                    value={this.state.type_id || ""}
                                    onChange={this.handleChange}
                                    inputProps={{
                                      name: "type_id",
                                      id: "type_id",
                                    }}
                                    readOnly={readOnly}
                                    disabled={
                                      this.state.manage_location_name !==
                                      "Kiosk"
                                    }
                                  >
                                    {boxTypes &&
                                      boxTypes.map((type, index) => (
                                        <MenuItem
                                          key={index}
                                          value={type.id}
                                          selected
                                          className={classes.menuItem}
                                        >
                                          {type.label}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                              )}
                            </div>
                            <div className={classes.rightChild}>
                              <div className={classes.dropbox}>
                                {readOnly ? (
                                  <div>
                                    {!this.state.avatarPreview && (
                                      <AddBoxImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.avatarPreview && (
                                      <img
                                        alt=""
                                        src={this.state.avatarPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <Dropzone
                                    id="avatardropzone"
                                    onDrop={this.handleDrop.bind(this)}
                                    className={classes.innerBox}
                                  >
                                    {!this.state.avatarPreview && (
                                      <AddBoxImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                    {this.state.avatarPreview && (
                                      <img
                                        alt=""
                                        src={this.state.avatarPreview}
                                        className={classes.dropPic}
                                      />
                                    )}
                                  </Dropzone>
                                )}
                              </div>
                              <div
                                variant="caption"
                                style={{ paddingTop: "40px" }}
                              >
                                <p className={classes.captionText}>
                                  {t("Location.Details.UploadImageTitle")}
                                </p>
                                <Button onClick={this.removeImg}>
                                  {t("Location.Details.RemoveImageButton")}
                                </Button>
                              </div>
                            </div>
                          </div>
                          <Typography
                            variant="title"
                            style={{
                              paddingTop: "40px",
                              fontSize: "1.3125rem",
                              fontWeight: 500,
                              lineHeight: "1.16667em",
                            }}
                          >
                            {t("Location.Details.LocationAddress")}
                          </Typography>
                          <div style={{ display: "flex" }}>
                            <TextValidator
                              margin="dense"
                              className={classes.halfTextField}
                              value={this.state.address1}
                              id="address1"
                              name="address1"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 100,
                              }}
                              label={t("Location.Details.AddressLine1")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterFirstName"),
                                t("Validation.UseAlphaDigits"),
                              ]}
                              variant="standard"
                            />
                            <TextField
                              className={classes.halfTextField}
                              margin="normal"
                              defaultValue={this.state.address2}
                              id="address2"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 100,
                                autocomplete: "new-password",
                                form: {
                                  autocomplete: "off",
                                },
                              }}
                              label={t("Location.Details.AddressLine2")}
                              placeholder=""
                              onBlur={this.handleChange}
                              style={{ marginTop: "4px" }}
                              variant="standard"
                            />
                          </div>
                          <br />
                          <div style={{ display: "flex" }}>
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.city}
                              id="city"
                              name="city"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t("Location.Details.City")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterCity"),
                                t("Validation.UseAlphabets"),
                              ]}
                              variant="standard"
                            />
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.state}
                              id="state"
                              name="state"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 50,
                              }}
                              label={t("Location.Details.State")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={["required"]}
                              errorMessages={[
                                t("Validation.EnterState"),
                                t("Validation.UseAlphabets"),
                              ]}
                              variant="standard"
                            />
                            <TextValidator
                              className={classes.ThirdTextField}
                              margin="normal"
                              value={this.state.zip}
                              id="zip"
                              name="zip"
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 6,
                              }}
                              label={t("Location.Details.Zip")}
                              placeholder=""
                              onChange={this.handleChange}
                              validators={[t("Validation.Required")]}
                              errorMessages={[
                                t("Validation.zip"),
                                t("Validation.UseDigits"),
                              ]}
                              variant="standard"
                            />
                          </div>
                          <br />
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.handleClose}
                            color="primary"
                            className={classes.primaryButton}
                          >
                            {this.state.operation === "View"
                              ? t("Location.CloseButton")
                              : t("Location.CancelButton")}
                          </Button>
                          {this.state.operation !== "View" && (
                            <Button
                              type="submit"
                              onClick={
                                this.state.operation === "Add"
                                  ? this.handleSubmit
                                  : this.handleUpdate
                              }
                              disabled={this.state.isButtonDisabled}
                              color="primary"
                              className={classes.primaryButton}
                            >
                              {this.state.operation === "Edit"
                                ? t("Location.UpdateLocationButton")
                                : t("Location.AddLocationButton")}
                            </Button>
                          )}
                        </DialogActions>
                      </ValidatorForm>
                    </div>
                  </TabContainer>
                  {/* Add on tab */}
                  <TabContainer dir={theme.direction}>
                    <div
                      className={classes.paddedBoxDivEdit}
                      style={{ paddingLeft: "2%" }}
                    >
                      <ValidatorForm
                        ref="form"
                        onSubmit={
                          this.state.operation === "Add"
                            ? this.handleSubmit
                            : this.handleUpdate
                        }
                      >
                        <div className={classes.twoChildren}>
                          <div style={{ marginBottom: "16px" }}>
                            {t("Location.POS.SelectPaymentGateway")}
                            <Select
                              style={{ width: "455px" }}
                              value={this.state.paymentType || ""}
                              onChange={this.handleChangePaymentGateway}
                              readOnly={this.state.operation === "View"}
                              inputProps={{
                                name: "paymentType",
                                id: "paymentType",
                              }}
                              variant="standard"
                            >
                              {this.state &&
                                this.state.paymentGateways &&
                                this.state.paymentGateways.map(
                                  (type, index) => (
                                    <MenuItem
                                      key={index}
                                      value={type && type.id}
                                      selected
                                    >
                                      {type && type.payment_type}
                                    </MenuItem>
                                  )
                                )}
                            </Select>
                          </div>
                          <div
                            className={classes.leftChild}
                            style={{ marginLeft: "3%" }}
                          >
                            {this.state &&
                              this.state.paymentType ===
                              PaymentGatewayTypes.GLOBAL_PAYMENTS ? (
                              <div>
                                <FormControl className={classes.formControl}>
                                  <InputLabel
                                    htmlFor="XWebId"
                                    sx={{ ml: "-15px" }}
                                  >
                                    {t("Location.POS.WebID")}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldPOS}
                                    margin="normal"
                                    value={this.state.XWebId || ""}
                                    id="XWebId"
                                    name="XWebId"
                                    type={
                                      this.state.isXWebIdSecretVisible
                                        ? "text"
                                        : "password"
                                    }
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label={t("Location.POS.WebID")}
                                    placeholder=""
                                    onChange={this.handleChange}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle XWebId visibility"
                                          onClick={
                                            this.handleShowHideXWebIdSecrets
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state.isXWebIdSecretVisible ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                        <Tooltip
                                          title={xWebId}
                                          className={classes.customWidth}
                                        >
                                          <Help
                                            className={classes.helpIcon}
                                          ></Help>
                                        </Tooltip>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                                <FormControl className={classes.formControl}>
                                  <InputLabel
                                    htmlFor="XWebTerminalId"
                                    sx={{ ml: "-15px" }}
                                  >
                                    {t("Location.POS.WebTerminalID")}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldPOS}
                                    margin="normal"
                                    value={this.state.XWebTerminalId || ""}
                                    id="XWebTerminalId"
                                    name="XWebTerminalId"
                                    type={
                                      this.state.isXWebTerminalIdSecretVisible
                                        ? "text"
                                        : "password"
                                    }
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label={t("Location.POS.WebTerminalID")}
                                    placeholder=""
                                    onChange={this.handleChange}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle XWebTerminalId visibility"
                                          onClick={
                                            this
                                              .handleShowHideXWebTerminalIdSecrets
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state
                                            .isXWebTerminalIdSecretVisible ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                        <Tooltip
                                          title={xWebTerminalId}
                                          className={classes.customWidth}
                                        >
                                          <Help
                                            className={classes.helpIcon}
                                          ></Help>
                                        </Tooltip>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                                <FormControl className={classes.formControl}>
                                  <InputLabel
                                    htmlFor="XWebAuthKey"
                                    sx={{ ml: "-15px" }}
                                  >
                                    {t("Location.POS.WebAuthKey")}
                                  </InputLabel>
                                  <Input
                                    className={classes.halfTextFieldPOS}
                                    margin="normal"
                                    value={this.state.XWebAuthKey || ""}
                                    id="XWebAuthKey"
                                    name="XWebAuthKey"
                                    type={
                                      this.state.isXWebAuthKeySecretVisible
                                        ? "text"
                                        : "password"
                                    }
                                    inputProps={{ readOnly: Boolean(readOnly) }}
                                    label={t("Location.POS.WebAuthKey")}
                                    placeholder=""
                                    onChange={this.handleChange}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle XWebAuthKey visibility"
                                          onClick={
                                            this
                                              .handleShowHideXWebAuthKeySecrets
                                          }
                                          onMouseDown={
                                            this.handleMouseDownSecrets
                                          }
                                        >
                                          {this.state
                                            .isXWebAuthKeySecretVisible ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                        <Tooltip
                                          title={xWebAuthKey}
                                          className={classes.customWidth}
                                        >
                                          <Help
                                            className={classes.helpIcon}
                                          ></Help>
                                        </Tooltip>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                                <FormControl>
                                  <InputLabel
                                    htmlFor="Region"
                                    sx={{ ml: "-15px" }}
                                  >
                                    {t("Location.POS.Region")}
                                  </InputLabel>
                                  <Select
                                    style={{ width: "455px" }}
                                    value={this.state.selected_regioin || ""}
                                    onChange={this.handleChangeRegion}
                                    readOnly={this.state.operation === "View"}
                                    inputProps={{
                                      name: "selected_regioin",
                                      id: "selected_regioin",
                                    }}
                                    variant="standard"
                                  >
                                    {this.state &&
                                      this.state.countryList &&
                                      this.state.countryList.map &&
                                      this.state.countryList.map(
                                        (cl, index) => (
                                          <MenuItem
                                            key={index}
                                            value={cl && cl.id}
                                            selected
                                          >
                                            {`${cl && cl.region} (${cl &&
                                              cl.language})`}
                                          </MenuItem>
                                        )
                                      )}
                                  </Select>
                                </FormControl>
                              </div>
                            ) : (
                              <FormControl className={classes.formControl}>
                                <InputLabel
                                  htmlFor="XWebId"
                                  sx={{ ml: "-15px" }}
                                >
                                  {t("Location.POS.SerialNumber")}
                                </InputLabel>
                                <Input
                                  className={classes.halfTextFieldPOS}
                                  margin="normal"
                                  value={this.state.serial_number || ""}
                                  id="serial_number"
                                  name="serial_number"
                                  type="number"
                                  inputProps={{ readOnly: Boolean(readOnly) }}
                                  label={t("Location.POS.SerialNumber")}
                                  onChange={this.handleChange}
                                />
                              </FormControl>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            bottom: "0",
                            width: "100%",
                          }}
                        >
                          <DialogActions sx={{ padding: "8px 28px 8px 8px" }}>
                            <Button
                              onClick={this.handleClose}
                              color="primary"
                              className={classes.primaryButton}
                            >
                              {this.state.operation === "View"
                                ? t("Location.CloseButton")
                                : t("Location.CancelButton")}
                            </Button>
                            {this.state.operation !== "View" && (
                              <Button
                                type="submit"
                                onClick={
                                  this.state.operation === "Add"
                                    ? this.handleSubmit
                                    : this.handleUpdate
                                }
                                disabled={this.state.isButtonDisabled}
                                color="primary"
                                className={classes.primaryButton}
                              >
                                {this.state.operation === "Edit"
                                  ? t("Location.UpdateLocationButton")
                                  : t("Location.AddLocationButton")}
                              </Button>
                            )}
                          </DialogActions>
                        </div>
                      </ValidatorForm>
                    </div>
                  </TabContainer>
                </SwipeableViews>
              </div>
            )}
          </Dialog>

          <EnhancedTableToolbar
            numSelected={selected.length}
            add={this.addBox}
            deleteBoxes={this.deleteBoxes}
            editBox={this.editBox}
            confirmDelete={this.confirmDelete}
            badd={this.state.boxadd}
            bdelete={this.state.boxdelete}
            clearFilters={this.clearFilters}
          />
          <ReportsAGGrid
            columnDefs={columnDefs}
            sideBar={false}
            suppressMenuHide={true}
            defaultColDef={{
              flex: 1,
              minWidth: 150,
              floatingFilter: true,
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: [{
                  displayKey: 'searchtext',
                  displayName: 'Search Text',
                  predicate: (cellValue) => cellValue
                }],
                maxNumConditions: 1,
              },
              resizable: true,
              sortable: true,
              menuTabs: ['generalMenuTab', 'columnsMenuTab'],

            }}
            rowHeight={45}
            onGridReady={this.onGridReady}
            getRowId={(params) => params.data.id}
            onRowSelected={this.onRowSelected}
          />
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  withTranslation()(EnhancedTable)
);



// WEBPACK FOOTER //
// ./src/components/box-list/index.js